// Myanmar (Burmese) UI text, keyed by the English source text passed to t()/tf().
// Keep entries short and natural; missing keys fall back to English.
export const my: Record<string, string> = {
  'DONE':'ပြီးပြီ','HOME':'ပင်မ','PLAY':'ကစားမယ်','READY?':'အဆင်သင့်လား?','Who with?':'ဘယ်သူနဲ့?','FRIEND':'သူငယ်ချင်း','SOMEONE NEW':'လူသစ်တစ်ယောက်','GROUP':'အဖွဲ့',
  'PLAY AGAIN':'ထပ်ကစားမယ်','ALL PEOPLE':'အားလုံး','Choose the energy.':'ဂိမ်းပုံစံရွေးပါ။','PLAY WITH A FRIEND':'သူငယ်ချင်းနဲ့ ကစားမယ်','PICK A MOMENT':'Moment တစ်ခု ရွေးပါ','THINK ALIKE':'အတွေးတူမလား','SAME BRAIN':'အတွေးတူ','Pick the same answer.':'အဖြေတူအောင် ရွေးပါ။',
  'PREDICT THEM':'သူတို့ကို ခန့်မှန်း','READ ME':'ငါ့ကိုခန့်မှန်း','Guess what they’ll pick.':'သူတို့ ဘာရွေးမလဲ ခန့်မှန်းပါ။','AVOID THEIR BRAIN':'မတူအောင်ရွေး','DON’T MATCH':'မတူအောင်ရွေး','DON\'T MATCH':'မတူအောင်ရွေး','Pick differently.':'မတူတဲ့အဖြေ ရွေးပါ။',
  'ABOUT YOU':'သင့်အကြောင်း','QUIZ':'မေးခွန်းဂိမ်း','Ten questions. See who knows you best.':'မေးခွန်း ၁၀ ခု။ သင့်ကို ဘယ်သူအကောင်းဆုံး သိလဲ ကြည့်မယ်။','BACK':'နောက်သို့','NEXT':'နောက်တစ်ခု',
  'YOU':'သင်','BOTH IN.':'နှစ်ယောက်လုံး ရွေးပြီးပြီ။','DIFFERENT':'မတူဘူး','ANOTHER':'နောက်တစ်ပွဲ','ANOTHER MOMENT':'နောက် Moment တစ်ခု','REMATCH':'ပြန်ကစားမယ်','REMATCH · DEEP':'DEEP ပြန်ကစားမယ်','CHALLENGE SOMEBODY':'တစ်ယောက်ယောက်ကို ဖိတ်မယ်','DEEP':'နက်နက်ရှိုင်းရှိုင်း',
  'Game ended.':'ဂိမ်းပြီးသွားပြီ။','You ended this game.':'သင် ဒီဂိမ်းကို အဆုံးသတ်လိုက်တယ်။','This game expired.':'ဒီဂိမ်း သက်တမ်းကုန်သွားပြီ။','Restoring your game…':'ဂိမ်းကို ပြန်ဖွင့်နေပါတယ်…','Preparing Round 1…':'ပထမအချီ ပြင်ဆင်နေပါတယ်…',
  'ANSWER PRESERVED':'အဖြေကို သိမ်းထားပါတယ်','TRY AGAIN':'ပြန်ကြိုးစား','TRYING…':'ကြိုးစားနေပါတယ်…','MATCH':'တူတယ်','THEIR PICK':'သူတို့ရွေးတာ','YOU PICKED':'သင်ရွေးတာ','BOTH PICKED':'နှစ်ယောက်လုံး ရွေးတာ',
  'QUICK QUIZ':'အမြန် မေးခွန်းဂိမ်း','CUSTOM QUIZ':'ကိုယ်ပိုင် မေးခွန်းဂိမ်း','MY ANSWERS':'ကျွန်တော့်/ကျွန်မ အဖြေများ','MAKE QUIZ':'မေးခွန်းဂိမ်းလုပ်မယ်','SHARE':'မျှဝေမယ်','SHARE QUIZ':'မေးခွန်းဂိမ်း မျှဝေမယ်','SHARE WITH FRIEND':'သူငယ်ချင်းကို မျှဝေမယ်','SHARE PUBLICLY':'အများသို့ မျှဝေမယ်',
  'PUBLISH & SHARE':'တင်ပြီး မျှဝေမယ်','FRIENDBOARD':'သူငယ်ချင်းရလဒ်','VIEW ANSWERS':'အဖြေတွေ ကြည့်မယ်','SAVE':'သိမ်းမယ်','SAVE QUIZ':'မေးခွန်းဂိမ်း သိမ်းမယ်','YOUR SCORE':'သင့်ရမှတ်','QUESTION':'မေးခွန်း','CORRECT':'မှန်တယ်','WRONG':'မှားတယ်',
  'YOUR UTAGE PROFILE':'သင့် UTAGE ပရိုဖိုင်','NAME':'အမည်','SAVE NAME':'အမည် သိမ်းမယ်','USE A DIFFERENT PHOTO':'ဓာတ်ပုံပြောင်းမယ်','CHANGE PHOTO':'ဓာတ်ပုံပြောင်းမယ်','LANGUAGE':'ဘာသာစကား','English':'English','Myanmar (Burmese)':'မြန်မာ','Myanmar':'မြန်မာ',
  'Opening UTAGE…':'UTAGE ဖွင့်နေပါတယ်…','Open UTAGE inside Telegram.':'Telegram ထဲကနေ UTAGE ကို ဖွင့်ပါ။','Couldn’t open UTAGE.':'UTAGE ကို ဖွင့်လို့မရပါ။','MODERATION':'စီမံခန့်ခွဲမှု',
  'Someone new':'လူသစ်တစ်ယောက်','GO DEEP':'ပိုနက်နက် သွားမယ်','REMATCH · NORMAL':'ပုံမှန် ပြန်ကစားမယ်','WAITING':'စောင့်နေပါတယ်','CANCEL':'ပယ်ဖျက်မယ်','SHARE AGAIN':'ထပ်မျှဝေမယ်','SHARE INVITE':'ဖိတ်ကြားချက် မျှဝေမယ်','END GAME':'ဂိမ်းအဆုံးသတ်မယ်','ROUND':'အချီ','PREVIOUS':'အရင်တစ်ခု','LOCKED':'ရွေးပြီး','ANSWERED':'ဖြေပြီး','PLAYED':'ကစားပြီး','QUESTIONS':'မေးခွန်းများ','SHARE MY SCORE':'ရမှတ်ကို မျှဝေမယ်','FIND SOMEONE':'လူတစ်ယောက် ရှာမယ်','RETRY SEARCH':'ပြန်ရှာမယ်','CHALLENGE A FRIEND':'သူငယ်ချင်းကို ဖိတ်မယ်','PAIR':'နှစ်ယောက်','Choose an interaction. The game introduces the human.':'ဂိမ်းပုံစံရွေးပါ။ UTAGE က လူတစ်ယောက်နဲ့ ချိတ်ပေးမယ်။','OPEN A ROOM':'အခန်းဖွင့်မယ်','CREATE GROUP':'အဖွဲ့ဖန်တီးမယ်','JOIN GROUP':'အဖွဲ့ထဲဝင်မယ်','GROUP LOBBY':'အဖွဲ့စောင့်ခန်း','I’M READY':'အဆင်သင့်ပါပြီ','I’M NOT READY':'မအဆင်သင့်သေးဘူး','INVITE PEOPLE':'လူတွေကို ဖိတ်မယ်','START GROUP':'အဖွဲ့ဂိမ်းစမယ်','CANCEL ROOM':'အခန်းပယ်ဖျက်မယ်','LEAVE GROUP':'အဖွဲ့က ထွက်မယ်','SEE GROUP RESULT':'အဖွဲ့ရလဒ် ကြည့်မယ်',
  // Part A: home, pair games, profile, someone new
  'Loading Arcade…': 'Arcade ကို ဖွင့်နေပါတယ်…',
  'Could not open this challenge.': 'ဒီစိန်ခေါ်မှုကို ဖွင့်လို့ မရပါ။',
  'Could not create a challenge.': 'စိန်ခေါ်မှု မဖန်တီးနိုင်ပါ။',
  'Could not open sharing.': 'မျှဝေမှုကို ဖွင့်လို့ မရပါ။',
  'Could not accept this challenge.': 'ဒီစိန်ခေါ်မှုကို လက်ခံလို့ မရပါ။',
  'Could not cancel this challenge.': 'ဒီစိန်ခေါ်မှုကို ပယ်ဖျက်လို့ မရပါ။',
  'Friend challenges are unavailable.': 'သူငယ်ချင်းစိန်ခေါ်မှုများ လောလောဆယ် မရနိုင်ပါ။',
  'You can return Home and use any available play option.': 'ပင်မစာမျက်နှာကို ပြန်သွားပြီး ရနိုင်တဲ့ ဂိမ်းတွေကို ကစားနိုင်ပါတယ်။',
  'Open your UTAGE profile': 'သင့် UTAGE ပရိုဖိုင်ကို ဖွင့်မယ်',
  'Hey {name}.': 'မင်္ဂလာပါ {name}။',
  'UTAGE ARCADE · 20 GAMES': 'UTAGE ARCADE · ဂိမ်း ၂၀',
  '20 games. One rivalry.': 'ဂိမ်း ၂၀။ ပြိုင်ဘက် တစ်ယောက်။',
  'Solo runs + same-seed friend challenges': 'တစ်ယောက်တည်းကစား + သူငယ်ချင်းနဲ့ တူညီတဲ့ပွဲ စိန်ခေါ်',
  'Some play options are unavailable for this account.': 'ဒီအကောင့်အတွက် ဂိမ်းအချို့ကို မရနိုင်ပါ။',
  '{count} game': 'ဂိမ်း {count} ပွဲ',
  '{count} games': 'ဂိမ်း {count} ပွဲ',
  'Avg {score}/10': 'ပျမ်းမျှ {score}/10',
  'Opening your challenge…': 'သင့်စိန်ခေါ်မှုကို ဖွင့်နေပါတယ်…',
  'Challenge unavailable.': 'စိန်ခေါ်မှု မရနိုင်ပါ။',
  'CHALLENGE CLOSED': 'စိန်ခေါ်မှု ပိတ်သွားပြီ',
  'This one is already in motion.': 'ဒီပွဲက စတင်ပြီးသွားပါပြီ။',
  'The challenge has been claimed. Start a fresh human moment from Home.': 'ဒီစိန်ခေါ်မှုကို တစ်ယောက်ယောက် လက်ခံပြီးပါပြီ။ ပင်မစာမျက်နှာကနေ အသစ်တစ်ခု စတင်ပါ။',
  'START YOUR OWN': 'ကိုယ်ပိုင် စတင်မယ်',
  'This moment has passed.': 'ဒီအချိန် ကျော်လွန်သွားပါပြီ။',
  'This challenge was cancelled.': 'ဒီစိန်ခေါ်မှုကို ပယ်ဖျက်လိုက်ပါပြီ။',
  'Nothing went wrong. Open a fresh challenge whenever you’re ready.': 'ဘာမှ မှားယွင်းတာ မရှိပါ။ အဆင်သင့်ဖြစ်တဲ့အခါ စိန်ခေါ်မှုအသစ် ဖွင့်ပါ။',
  'The sender intentionally closed this challenge.': 'ပို့သူက ဒီစိန်ခေါ်မှုကို ပိတ်လိုက်ပါတယ်။',
  'QUESTION SENT': 'မေးခွန်း ပို့ပြီးပြီ',
  'PLAY AGAIN INVITE': 'ပြန်ကစားဖို့ ဖိတ်ကြားချက်',
  'CHALLENGE SENT': 'စိန်ခေါ်မှု ပို့ပြီးပြီ',
  'QUESTION PRESERVED': 'မေးခွန်းကို သိမ်းထားပါတယ်',
  'CHALLENGE PRESERVED': 'စိန်ခေါ်မှုကို သိမ်းထားပါတယ်',
  'Waiting for {name}…': '{name} ကို စောင့်နေပါတယ်…',
  'Your friend has it.': 'သင့်သူငယ်ချင်း လက်ထဲ ရောက်နေပါပြီ။',
  'This private question is only for {name}. It opens when they accept.': 'ဒီကိုယ်ပိုင်မေးခွန်းက {name} အတွက်ပဲ ဖြစ်ပါတယ်။ လက်ခံတဲ့အခါ ပွင့်လာပါမယ်။',
  'This invite is only for {name}. The room opens when they accept.': 'ဒီဖိတ်ကြားချက်က {name} အတွက်ပဲ ဖြစ်ပါတယ်။ လက်ခံတဲ့အခါ အခန်း ပွင့်လာပါမယ်။',
  'The room opens the moment they accept. No countdown, no pressure.': 'လက်ခံလိုက်တာနဲ့ အခန်း ပွင့်လာပါမယ်။ အချိန်ကန့်သတ်ချက် မရှိ၊ ဖိအား မရှိပါ။',
  'CANCEL QUESTION': 'မေးခွန်း ပယ်ဖျက်မယ်',
  'CANCEL CHALLENGE': 'စိန်ခေါ်မှု ပယ်ဖျက်မယ်',
  'YOUR QUESTION': 'သင့်မေးခွန်း',
  '{name} made one private question for you.': '{name} က သင့်အတွက် ကိုယ်ပိုင်မေးခွန်း တစ်ခု ပြုလုပ်ထားပါတယ်။',
  'Go beyond small talk with {name}.': '{name} နဲ့ ပိုနက်နက်ရှိုင်းရှိုင်း စကားပြောကြည့်ပါ။',
  'How well do you really know {name}?': '{name} ကို သင် ဘယ်လောက် သိလဲ?',
  "Can you stay out of {name}'s head?": "{name} နဲ့ အတွေးမတူအောင် ရှောင်နိုင်မလား?",
  'Both choose privately. Then UTAGE reveals the two human answers.': 'နှစ်ယောက်လုံး လျှို့ဝှက်စွာ ရွေးပါ။ ပြီးရင် UTAGE က အဖြေနှစ်ခုကို ပြပါမယ်။',
  'You, {name}, ten rounds, one reveal at a time.': 'သင်နဲ့ {name}၊ ၁၀ ချီ၊ တစ်ချီချင်း ရလဒ်ပြမယ်။',
  '{name} HAS A QUESTION': '{name} မှာ မေးခွန်းတစ်ခု ရှိတယ်',
  '{name} CHALLENGED YOU': '{name} က သင့်ကို စိန်ခေါ်ထားတယ်',
  'OPENING YOUR ROOM…': 'အခန်းကို ဖွင့်နေပါတယ်…',
  'ANSWER WITH {name}': '{name} နဲ့ အတူ ဖြေမယ်',
  'PLAY WITH {name}': '{name} နဲ့ ကစားမယ်',
  'Could not update the game.': 'ဂိမ်းကို အပ်ဒိတ်လုပ်လို့ မရပါ။',
  '{name} ended the game.': '{name} က ဂိမ်းကို အဆုံးသတ်လိုက်ပါတယ်။',
  'Your old session is closed. Start a fresh human moment from Home.': 'ယခင်ဂိမ်း ပိတ်သွားပါပြီ။ ပင်မစာမျက်နှာကနေ အသစ်တစ်ခု စတင်ပါ။',
  'YOU TWO THINK': 'သင်တို့နှစ်ယောက် အတွေးတူမှု',
  'SUSPICIOUSLY ALIKE.': 'သံသယဖြစ်လောက်အောင် တူတယ်။',
  'SOMEWHERE IN THE MIDDLE.': 'အလယ်အလတ်လောက် တူတယ်။',
  'TWO ORIGINAL HUMANS.': 'ကိုယ်ပိုင်ဟန်ရှိတဲ့ လူနှစ်ယောက်။',
  'TWO ORIGINAL BRAINS.': 'ကိုယ်ပိုင်အတွေးရှိတဲ့ ဦးနှောက်နှစ်ခု။',
  '{matches} of {total} moments matched. The differences count too.': '{total} ခုထဲက {matches} ခု တူခဲ့တယ်။ မတူတာတွေလည်း အရေးပါပါတယ်။',
  'YOU READ EACH OTHER': 'တစ်ယောက်ကိုတစ်ယောက် ခန့်မှန်းနိုင်မှု',
  'ALMOST TELEPATHIC.': 'စိတ်ချင်း ဆက်နေသလိုပဲ။',
  'YOU CAUGHT THE SIGNAL.': 'အရိပ်အမြွက်ကို ဖမ်းမိတယ်။',
  'MORE TO DISCOVER.': 'သိစရာတွေ ကျန်သေးတယ်။',
  '{correct} of {total} reads landed. Every surprise revealed something.': '{total} ကြိမ်ထဲက {correct} ကြိမ် မှန်ခဲ့တယ်။ မထင်မှတ်တာတိုင်းက တစ်ခုခုကို ပြောပြတယ်။',
  'THE READ IS IN.': 'ခန့်မှန်းချက် ရောက်လာပြီ။',
  '{name} ACTUALLY': '{name} တကယ်ရွေးတာ',
  '{name} PREDICTED': '{name} ခန့်မှန်းတာ',
  'READ CORRECTLY': 'မှန်အောင် ခန့်မှန်းနိုင်တယ်',
  'SURPRISE': 'မထင်မှတ်ထားဘူး',
  'YOUR ACTUAL CHOICE': 'သင် တကယ်ရွေးမယ့်အဖြေ',
  'READ {name}': '{name} ကို ခန့်မှန်းပါ',
  'What would {name} choose?': '{name} ဘာရွေးမလဲ?',
  'YOU DODGED EACH OTHER': 'တစ်ယောက်ကိုတစ်ယောက် ရှောင်နိုင်မှု',
  'EXPERT AVOIDANCE.': 'ရှောင်တာ ကျွမ်းကျင်တယ်။',
  'A CLEAN ESCAPE.': 'သပ်သပ်ရပ်ရပ် လွတ်မြောက်ခဲ့တယ်။',
  'YOUR BRAINS KEPT MEETING. 😂': 'အတွေးတွေက ခဏခဏ ဆုံနေတယ်။ 😂',
  'You survived {survived} of {total} rounds.': '{total} ချီထဲက {survived} ချီ လွတ်မြောက်ခဲ့တယ်။',
  'SURVIVED': 'လွတ်သွားတယ်',
  'BOOM — MATCHED': 'ဘွမ်း — တူသွားပြီ',
  'SAME': 'တူတယ်',
  'MATCHED': 'တူသွားတယ်',
  'reconnecting…': 'ပြန်ချိတ်ဆက်နေတယ်…',
  'locked in': 'ရွေးပြီးပြီ',
  'here': 'ရောက်နေတယ်',
  '{name} is reconnecting…': '{name} ပြန်ချိတ်ဆက်နေတယ်…',
  'Your friend': 'သင့်သူငယ်ချင်း',
  '{name} is choosing…': '{name} ရွေးနေတယ်…',
  '✓ LOCKED': '✓ ရွေးပြီး',
  'CONFIRMING…': 'အတည်ပြုနေတယ်…',
  ', locked': '၊ ရွေးပြီး',
  ', pending confirmation': '၊ အတည်ပြုရန် စောင့်နေ',
  'NORMAL': 'ပုံမှန်',
  'Rematch this Moment': 'ဒီ Moment ကို ပြန်ကစားမယ်',
  'Choose the next game depth': 'နောက်ဂိမ်းရဲ့ အနက်ကို ရွေးပါ',
  ' — waiting…': ' — စောင့်နေတယ်…',
  ' — choose the same mode.': ' — တူညီတဲ့ပုံစံကို ရွေးပါ။',
  "Couldn't confirm that the game ended yet.": "ဂိမ်းပြီးဆုံးကြောင်း မအတည်ပြုနိုင်သေးပါ။",
  'LEAVE SESSION': 'ဂိမ်းမှ ထွက်မယ်',
  'End this game?': 'ဒီဂိမ်းကို အဆုံးသတ်မလား?',
  'This ends it for everyone in this session.': 'ဒီဂိမ်းထဲက လူအားလုံးအတွက် ပြီးဆုံးသွားပါမယ်။',
  'KEEP PLAYING': 'ဆက်ကစားမယ်',
  'ENDING…': 'အဆုံးသတ်နေတယ်…',
  'React to this reveal': 'ဒီရလဒ်ကို တုံ့ပြန်ပါ',
  'React {reaction}': '{reaction} နဲ့ တုံ့ပြန်မယ်',
  'reacted {reaction}': 'က {reaction} နဲ့ တုံ့ပြန်တယ်',
  'YOUR PROGRESS IS SAFE': 'သင့်ကစားမှုကို သိမ်းထားပါတယ်',
  'RECONNECTING…': 'ပြန်ချိတ်ဆက်နေတယ်…',
  'CONNECTION INTERRUPTED · {preserved}': 'ချိတ်ဆက်မှု ပြတ်သွားတယ် · {preserved}',
  'COULDN’T RECONNECT · {preserved}': 'ပြန်မချိတ်ဆက်နိုင်ပါ · {preserved}',
  'Could not restore this game.': 'ဒီဂိမ်းကို ပြန်မဖွင့်နိုင်ပါ။',
  'Couldn’t restore this game.': 'ဒီဂိမ်းကို ပြန်မဖွင့်နိုင်ပါ။',
  'Your replay includes both players’ names, profile photos and game answers. Make it only if you’re both comfortable sharing that moment.': 'Replay ထဲမှာ ကစားသူနှစ်ယောက်လုံးရဲ့ နာမည်၊ ပရိုဖိုင်ဓာတ်ပုံနဲ့ အဖြေတွေ ပါဝင်ပါတယ်။ နှစ်ယောက်လုံး မျှဝေဖို့ အဆင်ပြေမှသာ ပြုလုပ်ပါ။',
  'Could not make the replay yet.': 'Replay ကို မပြုလုပ်နိုင်သေးပါ။',
  'Telegram could not open the share sheet on this device. You can still save the video below.': 'ဒီဖုန်းမှာ Telegram မျှဝေမှုကို မဖွင့်နိုင်ပါ။ အောက်က ဗီဒီယိုကို သိမ်းနိုင်ပါသေးတယ်။',
  'Download cancelled.': 'ဒေါင်းလုဒ်ကို ပယ်ဖျက်လိုက်ပါပြီ။',
  'Could not save the replay yet.': 'Replay ကို မသိမ်းနိုင်သေးပါ။',
  'GAME REPLAY': 'ဂိမ်း Replay',
  'THE MOMENT': 'အမှတ်တရ အချိန်',
  'MAKING YOUR REPLAY…': 'Replay ပြုလုပ်နေပါတယ်…',
  'MAKE VIDEO REPLAY': 'ဗီဒီယို Replay လုပ်မယ်',
  'SHARE VIDEO': 'ဗီဒီယို မျှဝေမယ်',
  'PREPARING…': 'ပြင်ဆင်နေပါတယ်…',
  'SAVE VIDEO': 'ဗီဒီယို သိမ်းမယ်',
  'Includes both players’ profiles and answers. Nothing is posted automatically.': 'ကစားသူနှစ်ယောက်လုံးရဲ့ ပရိုဖိုင်နဲ့ အဖြေတွေ ပါဝင်ပါတယ်။ ဘာမှ အလိုအလျောက် တင်မှာ မဟုတ်ပါ။',
  '{name} profile': '{name} ရဲ့ ပရိုဖိုင်',
  'Could not load your profile.': 'သင့်ပရိုဖိုင်ကို ဖွင့်လို့ မရပါ။',
  'Could not save your name.': 'သင့်နာမည်ကို မသိမ်းနိုင်ပါ။',
  'Could not save that photo.': 'ဒီဓာတ်ပုံကို မသိမ်းနိုင်ပါ။',
  'Could not change language.': 'ဘာသာစကား မပြောင်းနိုင်ပါ။',
  'Could not restore your Telegram photo.': 'Telegram ဓာတ်ပုံကို ပြန်မထားနိုင်ပါ။',
  'USE TELEGRAM PHOTO AGAIN': 'Telegram ဓာတ်ပုံကို ပြန်သုံးမယ်',
  'Could not restore your Telegram name.': 'Telegram နာမည်ကို ပြန်မထားနိုင်ပါ။',
  'USE TELEGRAM NAME AGAIN': 'Telegram နာမည်ကို ပြန်သုံးမယ်',
  'Saving…': 'သိမ်းနေပါတယ်…',
  'Photos provided by Pexels': 'ဓာတ်ပုံများကို Pexels မှ ပံ့ပိုးပေးပါသည်',
  'Could not restore matchmaking.': 'လူရှာခြင်းကို ပြန်မဖွင့်နိုင်ပါ။',
  'Could not search right now.': 'အခု မရှာနိုင်ပါ။',
  'Could not leave the queue yet.': 'စောင့်ဆိုင်းစာရင်းက မထွက်နိုင်သေးပါ။',
  'FOUND SOMEONE.': 'တစ်ယောက် တွေ့ပြီ။',
  '10 questions': 'မေးခွန်း ၁၀ ခု',
  'No one was ready yet.': 'အဆင်သင့်ဖြစ်နေတဲ့သူ မရှိသေးပါ။',
  'Looking for one real person…': 'တကယ့်လူတစ်ယောက်ကို ရှာနေပါတယ်…',
  'You can keep waiting or try the search again.': 'ဆက်စောင့်နိုင်သလို ပြန်ရှာကြည့်လို့လည်း ရပါတယ်။',
  'No fake counts. No ETA. We’ll update this only when a real person is ready.': 'အတုအယောင် ကိန်းဂဏန်း မပြပါ။ ခန့်မှန်းချိန် မပြပါ။ တကယ့်လူ အဆင်သင့်ဖြစ်မှသာ အသိပေးပါမယ်။',
  'CONTINUE WAITING': 'ဆက်စောင့်မယ်',
  'KEEP WAITING': 'ဆက်စောင့်မယ်',
  'Choose an interaction': 'ဂိမ်းပုံစံ ရွေးပါ',
  'SEARCHING…': 'ရှာနေပါတယ်…',
  // Part B: group, quiz, custom question, say it, safety
  "Could not save that reaction.": "တုံ့ပြန်မှုကို မသိမ်းနိုင်ပါ။",
  "Could not save this question for you two.": "ဒီမေးခွန်းကို သင်တို့နှစ်ယောက်အတွက် မသိမ်းနိုင်ပါ။",
  "Restoring your question…": "သင့်မေးခွန်းကို ပြန်ဖွင့်နေပါတယ်…",
  "Question ended.": "မေးခွန်း ပြီးဆုံးသွားပါပြီ။",
  "This question expired.": "ဒီမေးခွန်း သက်တမ်းကုန်သွားပါပြီ။",
  "Nothing social is implied. The session simply timed out.": "ဘာမှ ဆိုလိုချက် မရှိပါ။ အချိန်ကုန်သွားရုံပါပဲ။",
  "Opening the question…": "မေးခွန်းကို ဖွင့်နေပါတယ်…",
  "THEM": "သူတို့",
  "SAME CHOICE.": "အဖြေတူတယ်။",
  "DIFFERENT CHOICES.": "အဖြေမတူဘူး။",
  "No score. You just learned one real thing about each other.": "အမှတ်မရှိပါ။ တစ်ယောက်အကြောင်း တစ်ယောက် တကယ့်အရာတစ်ခု သိလိုက်ရတာပါ။",
  "SAVING…": "သိမ်းနေပါတယ်…",
  "SAVE THIS FOR US": "ကျွန်ုပ်တို့အတွက် သိမ်းထားမယ်",
  "SAVED FOR YOU TWO": "သင်တို့နှစ်ယောက်အတွက် သိမ်းထားပြီ",
  "YOU ASKED": "သင် မေးခဲ့တာ",
  "THEY ASKED": "သူတို့ မေးခဲ့တာ",
  "They": "သူတို့",
  "GROUP COMPLETE": "အဖွဲ့ဂိမ်း ပြီးပါပြီ",
  "EVERYONE WAS IN.": "အားလုံး ပါဝင်ခဲ့ကြတယ်။",
  "GROUP SYNC": "အဖွဲ့ အတွေးတူမှု",
  "{count} collective reveals": "အဖွဲ့လိုက် ရလဒ် {count} ကြိမ်",
  "ONE SHARED BRAIN.": "ဦးနှောက်တစ်ခုတည်း မျှသုံးနေသလိုပဲ။",
  "MANY BRAINS. ONE ROOM.": "ဦးနှောက်အများကြီး။ အခန်းတစ်ခုတည်း။",
  "GROUP READ": "အဖွဲ့ ခန့်မှန်းနိုင်မှု",
  "{correct} of {total} predictions landed": "ခန့်မှန်းချက် {total} ခုထဲက {correct} ခု မှန်ခဲ့တယ်",
  "YOU KNOW EACH OTHER.": "တစ်ယောက်ကိုတစ်ယောက် သိကြတယ်။",
  "STILL FULL OF SURPRISES.": "အံ့သြစရာတွေ အများကြီး ရှိသေးတယ်။",
  "GROUP SURVIVAL": "အဖွဲ့ လွတ်မြောက်နိုင်မှု",
  "{survived} of {total} rounds survived": "{total} ချီထဲက {survived} ချီ လွတ်မြောက်ခဲ့တယ်",
  "CHAOTIC COLLISIONS. 😂": "ရှုပ်ယှက်ခတ်အောင် တိုက်မိကြတယ်။ 😂",
  "Preparing the group game…": "အဖွဲ့ဂိမ်းကို ပြင်ဆင်နေပါတယ်…",
  "{count} participants": "ပါဝင်သူ {count} ယောက်",
  "{percent}% IN SYNC": "{percent}% အတွေးတူ",
  "{name} CHOSE {choice}": "{name} က {choice} ကို ရွေးခဲ့တယ်",
  "THE SPOTLIGHT": "အဓိကလူ",
  "BOOM — EVERYONE MATCHED": "ဘွမ်း — အားလုံး တူသွားပြီ",
  "REVEAL PRESERVED": "ရလဒ်ကို သိမ်းထားပါတယ်",
  "EVERYONE IN.": "အားလုံး ရွေးပြီးပြီ။",
  "read it right": "ယောက် မှန်အောင် ခန့်မှန်းခဲ့တယ်",
  "Nobody called it this time": "ဒီတစ်ခါ ဘယ်သူမှ မခန့်မှန်းနိုင်ခဲ့ဘူး",
  "React to the collective reveal": "အဖွဲ့ရလဒ်ကို တုံ့ပြန်ပါ",
  ", {count} reactions": "၊ တုံ့ပြန်မှု {count} ခု",
  "The host moves the room forward.": "အခန်းရှင်က ဆက်သွားပေးပါမယ်။",
  "YOUR REAL CHOICE · EVERYONE IS READING YOU": "သင့်တကယ့်ရွေးချယ်မှု · အားလုံးက သင့်ကို ခန့်မှန်းနေတယ်",
  "AVOID THE WHOLE ROOM": "အခန်းထဲက လူအားလုံးနဲ့ မတူအောင် ရွေးပါ",
  "WHAT WILL THE ROOM CHOOSE?": "အခန်းထဲက လူတွေ ဘာရွေးမလဲ?",
  "What would they choose?": "သူတို့ ဘာရွေးမလဲ?",
  "CHOICE PRESERVED": "ရွေးချယ်မှုကို သိမ်းထားပါတယ်",
  "{locked} / {total} LOCKED": "{locked} / {total} ရွေးပြီး",
  "Your choice is private. Waiting for the room…": "သင့်ရွေးချယ်မှုကို လျှို့ဝှက်ထားပါတယ်။ ကျန်တဲ့သူတွေကို စောင့်နေပါတယ်…",
  "Could not open this group.": "ဒီအဖွဲ့ကို ဖွင့်လို့ မရပါ။",
  "Could not update this group.": "ဒီအဖွဲ့ကို အပ်ဒိတ်လုပ်လို့ မရပါ။",
  "Could not create this group.": "ဒီအဖွဲ့ကို မဖန်တီးနိုင်ပါ။",
  "Pick the shared energy, then invite your people.": "ဂိမ်းပုံစံကို ရွေးပြီး သင့်လူတွေကို ဖိတ်ပါ။",
  "Choose a group interaction": "အဖွဲ့ဂိမ်းပုံစံ ရွေးပါ",
  "OPENING…": "ဖွင့်နေပါတယ်…",
  "Opening group…": "အဖွဲ့ကို ဖွင့်နေပါတယ်…",
  "Group unavailable.": "အဖွဲ့ကို မရနိုင်ပါ။",
  "GROUP CLOSED": "အဖွဲ့ ပိတ်သွားပြီ",
  "This room expired.": "ဒီအခန်း သက်တမ်းကုန်သွားပါပြီ။",
  "The host cancelled this room.": "အခန်းရှင်က ဒီအခန်းကို ပယ်ဖျက်လိုက်ပါတယ်။",
  "{name} OPENED A GROUP": "{name} က အဖွဲ့တစ်ခု ဖွင့်ထားတယ်",
  "This group has already started.": "ဒီအဖွဲ့ဂိမ်း စတင်ပြီးသွားပါပြီ။",
  "{joined} / {max} humans joined": "{max} ယောက်ထဲက {joined} ယောက် ဝင်ပြီးပြီ",
  "JOINING…": "ဝင်နေပါတယ်…",
  "ROOM PRESERVED": "အခန်းကို သိမ်းထားပါတယ်",
  "{ready} ready · minimum {min}": "{ready} ယောက် အဆင်သင့် · အနည်းဆုံး {min} ယောက်",
  "HOST": "အခန်းရှင်",
  "RECONNECTING": "ပြန်ချိတ်ဆက်နေတယ်",
  "✓ READY": "✓ အဆင်သင့်",
  "NOT READY": "အဆင်မသင့်သေး",
  "WAITING FOR {count} READY": "နောက်ထပ် {count} ယောက် အဆင်သင့်ဖြစ်ဖို့ စောင့်နေတယ်",
  "Cancel this group room?": "ဒီအဖွဲ့အခန်းကို ပယ်ဖျက်မလား?",
  "PHOTO": "ဓာတ်ပုံ",
  "{name}'S QUIZ": "{name} ရဲ့ မေးခွန်းဂိမ်း",
  "YOU KNOW THEM.": "သူတို့ကို သင် သိတယ်။",
  "PRETTY CLOSE.": "တော်တော် နီးစပ်တယ်။",
  "{percent}% of their answers landed.": "သူတို့အဖြေရဲ့ {percent}% ကို မှန်အောင် ခန့်မှန်းနိုင်ခဲ့တယ်။",
  "Your quiz answers": "သင့်ရဲ့ မေးခွန်းဂိမ်း အဖြေများ",
  "WHAT HAPPENED": "ဘာဖြစ်ခဲ့လဲ",
  "Your pick vs {name}'s real pick.": "သင်ရွေးတာနဲ့ {name} တကယ်ရွေးတာ။",
  "QUESTION {number}": "မေးခွန်း {number}",
  "{name} PICKED": "{name} ရွေးတာ",
  "Could not open this quiz.": "ဒီမေးခွန်းဂိမ်းကို ဖွင့်လို့ မရပါ။",
  "Could not make this quiz.": "ဒီမေးခွန်းဂိမ်းကို မပြုလုပ်နိုင်ပါ။",
  "Could not save this answer.": "ဒီအဖြေကို မသိမ်းနိုင်ပါ။",
  "Could not save this question.": "ဒီမေးခွန်းကို မသိမ်းနိုင်ပါ။",
  "Could not save that title.": "ခေါင်းစဉ်ကို မသိမ်းနိုင်ပါ။",
  "Could not publish this quiz.": "ဒီမေးခွန်းဂိမ်းကို မတင်နိုင်ပါ။",
  "Could not load quiz results.": "ရလဒ်များကို ဖွင့်လို့ မရပါ။",
  "Could not load those answers.": "အဖြေများကို ဖွင့်လို့ မရပါ။",
  "That saved quiz is no longer available.": "သိမ်းထားတဲ့ မေးခွန်းဂိမ်းကို မရနိုင်တော့ပါ။",
  "Could not open that quiz.": "ဒီမေးခွန်းဂိမ်းကို ဖွင့်လို့ မရပါ။",
  "Could not save that picture.": "ဒီပုံကို မသိမ်းနိုင်ပါ။",
  "Opening the quiz…": "မေးခွန်းဂိမ်းကို ဖွင့်နေပါတယ်…",
  "Quiz unavailable.": "မေးခွန်းဂိမ်းကို မရနိုင်ပါ။",
  "Could not finish this quiz.": "ဒီမေးခွန်းဂိမ်းကို မပြီးဆုံးနိုင်ပါ။",
  "Could not reveal that answer. Try again.": "အဖြေကို မပြနိုင်ပါ။ ပြန်ကြိုးစားပါ။",
  "✓ MATCH": "✓ တူတယ်",
  "✕ YOU PICKED": "✕ သင်ရွေးတာ",
  "Checking your guess…": "သင့်ခန့်မှန်းချက်ကို စစ်နေပါတယ်…",
  "Scoring…": "အမှတ်တွက်နေပါတယ်…",
  "Make something shareable.": "မျှဝေစရာ တစ်ခု ဖန်တီးပါ။",
  "Ten questions about you. Friends try to guess your answers.": "သင့်အကြောင်း မေးခွန်း ၁၀ ခု။ သူငယ်ချင်းတွေက သင့်အဖြေကို ခန့်မှန်းကြမယ်။",
  "SAVED ON THIS DEVICE": "ဒီဖုန်းမှာ သိမ်းထားတယ်",
  "CONTINUE QUIZ": "ဆက်လုပ်မယ်",
  "Pick up the quiz you were building.": "လုပ်လက်စ မေးခွန်းဂိမ်းကို ဆက်လုပ်ပါ။",
  "READY IN A MINUTE": "တစ်မိနစ်အတွင်း ပြီးမယ်",
  "UTAGE gives you 10 ready questions. Just choose your answers.": "UTAGE က အဆင်သင့် မေးခွန်း ၁၀ ခု ပေးပါမယ်။ သင့်အဖြေကိုပဲ ရွေးပါ။",
  "MAKE IT YOURS": "ကိုယ်ပိုင် ပြုလုပ်မယ်",
  "Make 10 questions, pick your own answers, then share it for friends to guess.": "မေးခွန်း ၁၀ ခု ရေးပြီး ကိုယ့်အဖြေကို ရွေးပါ။ ပြီးရင် သူငယ်ချင်းတွေ ခန့်မှန်းဖို့ မျှဝေပါ။",
  "YOUR QUIZZES": "သင့်မေးခွန်းဂိမ်းများ",
  "Draft": "မူကြမ်း",
  "{count} played": "{count} ယောက် ကစားပြီး",
  "Preparing 10 questions…": "မေးခွန်း ၁၀ ခု ပြင်ဆင်နေပါတယ်…",
  "Couldn’t make this quiz.": "ဒီမေးခွန်းဂိမ်းကို မပြုလုပ်နိုင်ပါ။",
  "{name}'S PICKS": "{name} ရဲ့ ရွေးချယ်မှုများ",
  "Now you know exactly what they chose. Use this information responsibly 😂": "အခု သူတို့ ဘာရွေးခဲ့လဲ အတိအကျ သိပါပြီ။ ဒီအချက်အလက်ကို တာဝန်သိသိ သုံးပါ 😂",
  "{count} PLAYED": "{count} ယောက် ကစားပြီး",
  "Tap someone to see every answer they picked.": "တစ်ယောက်ယောက်ကို နှိပ်ပြီး သူတို့ရွေးခဲ့တဲ့ အဖြေအားလုံးကို ကြည့်ပါ။",
  "Share the quiz and your people will appear here.": "မေးခွန်းဂိမ်းကို မျှဝေလိုက်ရင် သင့်လူတွေ ဒီမှာ ပေါ်လာပါမယ်။",
  "QUESTION ACCURACY": "မေးခွန်းအလိုက် မှန်ကန်မှု",
  "QUIZ READY": "မေးခွန်းဂိမ်း အဆင်သင့်",
  "Your 10 picks stay hidden. Choose where this quiz should travel.": "သင့်အဖြေ ၁၀ ခုကို ဖုံးထားပါမယ်။ ဒီမေးခွန်းဂိမ်းကို ဘယ်ကို ပို့မလဲ ရွေးပါ။",
  "ONE-TO-ONE": "တစ်ယောက်ချင်း",
  "Choose a private Telegram chat.": "Telegram ကိုယ်ပိုင်ချတ်တစ်ခု ရွေးပါ။",
  "OPEN IT UP": "အများကို ဖွင့်မယ်",
  "Post it to a Telegram group or channel so anyone there can play.": "Telegram အဖွဲ့ ဒါမှမဟုတ် ချန်နယ်မှာ တင်ပြီး ဘယ်သူမဆို ကစားနိုင်အောင် လုပ်ပါ။",
  "READY TO TRAVEL": "ပို့ဖို့ အဆင်သင့်",
  "Your answers are locked. Share this with friends — they get the same 10 questions and try to guess what YOU picked.": "သင့်အဖြေတွေကို သော့ခတ်ထားပါပြီ။ သူငယ်ချင်းတွေကို မျှဝေပါ — သူတို့က မေးခွန်း ၁၀ ခုတည်းကို ဖြေပြီး သင်ဘာရွေးခဲ့လဲ ခန့်မှန်းကြမယ်။",
  "questions": "မေးခွန်း",
  "played": "ကစားပြီး",
  "SAVE DRAFT & EXIT": "မူကြမ်းသိမ်းပြီး ထွက်မယ်",
  "Write the question and four choices first. After all 10, you’ll answer your own quiz so friends can guess what you picked.": "မေးခွန်းနဲ့ အဖြေလေးခုကို အရင်ရေးပါ။ ၁၀ ခုလုံး ပြီးရင် သူငယ်ချင်းတွေ ခန့်မှန်းနိုင်အောင် ကိုယ့်မေးခွန်းကို ကိုယ်တိုင် ဖြေရပါမယ်။",
  "Your draft stays private until you publish and share it.": "မတင်ခင်နဲ့ မမျှဝေခင်အထိ မူကြမ်းကို သင်တစ်ယောက်တည်းပဲ မြင်ရပါမယ်။",
  "SAVE QUESTION FIRST": "မေးခွန်းကို အရင်သိမ်းပါ",
  "When I upload a picture, let UTAGE review it for the shared image library.": "ပုံတင်တဲ့အခါ UTAGE ရဲ့ ပုံစုစည်းမှုအတွက် စစ်ဆေးခွင့် ပေးမယ်။",
  "Off by default. Only opt in for pictures you own or have permission to share.": "မူလအားဖြင့် ပိတ်ထားပါတယ်။ ကိုယ်ပိုင်ပုံ ဒါမှမဟုတ် မျှဝေခွင့်ရှိတဲ့ ပုံတွေအတွက်သာ ဖွင့်ပါ။",
  "SAVE & NEXT": "သိမ်းပြီး နောက်တစ်ခု",
  "SAVE QUESTION": "မေးခွန်း သိမ်းမယ်",
  "SET MY ANSWERS →": "ကိုယ့်အဖြေ သတ်မှတ်မယ် →",
  "{count} LOCKED": "{count} ခု ရွေးပြီး",
  "Pick what you would choose. Friends will answer the same question and UTAGE scores how many of your choices they guessed.": "သင်ဘာရွေးမလဲ ရွေးပါ။ သူငယ်ချင်းတွေက ဒီမေးခွန်းကိုပဲ ဖြေပြီး သင့်ရွေးချယ်မှု ဘယ်နှခု မှန်အောင် ခန့်မှန်းနိုင်လဲ UTAGE က အမှတ်ပေးပါမယ်။",
  "EDIT QUIZ": "မေးခွန်းဂိမ်း ပြင်မယ်",
  "Choose {count} more answer to unlock SHARE.": "မျှဝေဖို့ နောက်ထပ် အဖြေ {count} ခု ရွေးပါ။",
  "Choose {count} more answers to unlock SHARE.": "မျှဝေဖို့ နောက်ထပ် အဖြေ {count} ခု ရွေးပါ။",
  "QUESTION {number} / 10 · {count} ANSWERED": "မေးခွန်း {number} / 10 · {count} ခု ဖြေပြီး",
  "Pick the answer YOU would choose. Friends will try to guess your picks.": "သင်ရွေးမယ့် အဖြေကို ရွေးပါ။ သူငယ်ချင်းတွေက သင့်ရွေးချယ်မှုကို ခန့်မှန်းကြမယ်။",
  "Could not make the quiz replay yet.": "မေးခွန်းဂိမ်း Replay ကို မပြုလုပ်နိုင်သေးပါ။",
  "Could not save the quiz replay yet.": "မေးခွန်းဂိမ်း Replay ကို မသိမ်းနိုင်သေးပါ။",
  "QUIZ REPLAY": "မေးခွန်းဂိမ်း Replay",
  "GOT IT": "မှန်တယ်",
  "Includes the quiz creator, your profile and selected quiz answers. Nothing is posted automatically.": "မေးခွန်းဂိမ်း ဖန်တီးသူ၊ သင့်ပရိုဖိုင်နဲ့ ရွေးထားတဲ့ အဖြေတွေ ပါဝင်ပါတယ်။ ဘာမှ အလိုအလျောက် တင်မှာ မဟုတ်ပါ။",
  "This replay includes your name, the quiz creator’s name, profile photos and quiz answers. Make it only if you are comfortable sharing that moment.": "ဒီ Replay မှာ သင့်နာမည်၊ ဖန်တီးသူရဲ့ နာမည်၊ ပရိုဖိုင်ဓာတ်ပုံတွေနဲ့ အဖြေတွေ ပါဝင်ပါတယ်။ မျှဝေဖို့ အဆင်ပြေမှသာ ပြုလုပ်ပါ။",
  "Couldn't load safety controls yet.": "လုံခြုံရေး ထိန်းချုပ်မှုများကို မဖွင့်နိုင်သေးပါ။",
  "Couldn't save that yet.": "မသိမ်းနိုင်သေးပါ။",
  "SAFETY": "လုံခြုံရေး",
  "PRIVATE SAFETY": "ကိုယ်ပိုင် လုံခြုံရေး",
  "Choose a person": "လူတစ်ယောက် ရွေးပါ",
  "Close safety controls": "လုံခြုံရေး ထိန်းချုပ်မှုများကို ပိတ်မယ်",
  "CHOOSE SOMEONE ELSE": "တခြားတစ်ယောက် ရွေးမယ်",
  "Reports are private. Blocking prevents future matching, challenges, group joins, rematches, and SAY IT moments between you.": "တိုင်ကြားချက်တွေကို လျှို့ဝှက်ထားပါတယ်။ ပိတ်ဆို့လိုက်ရင် နောက်ထပ် ချိတ်ဆက်မှု၊ စိန်ခေါ်မှု၊ အဖွဲ့ဝင်ခြင်း၊ ပြန်ကစားခြင်းနဲ့ SAY IT တွေ သင်တို့ကြား ထပ်မဖြစ်တော့ပါ။",
  "✓ REPORT SAVED": "✓ တိုင်ကြားချက် သိမ်းပြီး",
  "Why are you reporting this?": "ဘာကြောင့် တိုင်ကြားတာလဲ?",
  "SUBMIT REPORT": "တိုင်ကြားမယ်",
  "Block {name}? You won't be connected again.": "{name} ကို ပိတ်ဆို့မလား? နောက်ထပ် ချိတ်ဆက်ပေးမှာ မဟုတ်တော့ပါ။",
  "UNBLOCK": "ပိတ်ဆို့မှု ဖြုတ်မယ်",
  "BLOCK {name}": "{name} ကို ပိတ်ဆို့မယ်",
  "PERSON": "ဒီလူ",
  "✓ BLOCKED": "✓ ပိတ်ဆို့ပြီး",
  "Loading safety controls…": "လုံခြုံရေး ထိန်းချုပ်မှုများကို ဖွင့်နေပါတယ်…",
  "Harassment": "နှောင့်ယှက်ခြင်း",
  "Sexual content": "လိင်ပိုင်းဆိုင်ရာ အကြောင်းအရာ",
  "Hate or abuse": "အမုန်းစကား ဒါမှမဟုတ် စော်ကားခြင်း",
  "Spam": "Spam",
  "Unsafe behavior": "အန္တရာယ်ရှိတဲ့ အပြုအမူ",
  "Other": "အခြား",
  "Couldn't start another SAY IT moment.": "နောက်ထပ် SAY IT ကို မစတင်နိုင်ပါ။",
  "Cancel this SAY IT moment?": "ဒီ SAY IT ကို ပယ်ဖျက်မလား?",
  "Could not open this moment.": "ဒီ Moment ကို ဖွင့်လို့ မရပါ။",
  "Opening this moment…": "ဒီ Moment ကို ဖွင့်နေပါတယ်…",
  "Couldn’t open SAY IT.": "SAY IT ကို ဖွင့်လို့ မရပါ။",
  "This moment is unavailable.": "ဒီ Moment ကို မရနိုင်ပါ။",
  "KEEP IT FUN": "ပေါ့ပေါ့ပါးပါး ထားမယ်",
  "{name} chose to keep this one light.": "{name} က ဒီတစ်ခါ ပေါ့ပေါ့ပါးပါးပဲ ထားဖို့ ရွေးခဲ့တယ်။",
  "You kept this one light.": "ဒီတစ်ခါ ပေါ့ပေါ့ပါးပါးပဲ ထားခဲ့တယ်။",
  "Nothing awkward. Nothing lost.": "ရှက်စရာ မရှိပါ။ ဆုံးရှုံးစရာလည်း မရှိပါ။",
  "MOMENT CLOSED": "Moment ပိတ်သွားပြီ",
  "This SAY IT moment expired.": "ဒီ SAY IT သက်တမ်းကုန်သွားပါပြီ။",
  "This SAY IT moment was cancelled.": "ဒီ SAY IT ကို ပယ်ဖျက်လိုက်ပါပြီ။",
  "A LITTLE DEEPER?": "နည်းနည်း ပိုနက်နက် သွားမလား?",
  "WAITING FOR {name}": "{name} ကို စောင့်နေတယ်",
  "If they say yes, UTAGE will ask you:": "သူတို့ လက်ခံရင် UTAGE က သင့်ကို ဒီလို မေးပါမယ်:",
  "They choose. No pressure, no countdown.": "သူတို့ ရွေးပါလိမ့်မယ်။ ဖိအား မရှိ၊ အချိန်ကန့်သတ်ချက် မရှိပါ။",
  "{name} WANTS TO SAY SOMETHING": "{name} တစ်ခုခု ပြောချင်နေတယ်",
  "One short human message. No chat thread.": "တိုတိုလေး စာတစ်စောင်။ ချတ်ဆက်တိုက် မရှိပါ။",
  "GO DEEPER": "ပိုနက်နက် သွားမယ်",
  "RECONNECTING… your choice is safe.": "ပြန်ချိတ်ဆက်နေတယ်… သင့်ရွေးချယ်မှုကို သိမ်းထားပါတယ်။",
  "{name} SAID YES": "{name} လက်ခံလိုက်ပြီ",
  "SAY IT.": "ပြောလိုက်ပါ။",
  "Your words": "သင့်စကား",
  "Keep it short. Make it yours.": "တိုတိုလေး ရေးပါ။ ကိုယ့်စကားနဲ့ ရေးပါ။",
  "SEND THIS": "ဒါကို ပို့မယ်",
  "UTAGE carries your words. It does not rewrite them or speak for you.": "UTAGE က သင့်စကားကို ပို့ပေးရုံပါပဲ။ ပြင်ရေးတာ ဒါမှမဟုတ် သင့်ကိုယ်စား ပြောတာ မလုပ်ပါ။",
  "YOU SAID YES": "သင် လက်ခံလိုက်ပြီ",
  "They’re writing one short thing. UTAGE won’t show typing status or pressure them.": "သူတို့ တိုတိုလေး ရေးနေပါတယ်။ UTAGE က စာရိုက်နေကြောင်း မပြသလို ဖိအားလည်း မပေးပါ။",
  "RECONNECTING… this moment is safe.": "ပြန်ချိတ်ဆက်နေတယ်… ဒီ Moment ကို သိမ်းထားပါတယ်။",
  "YOU WANTED THEM TO KNOW": "သူတို့ သိစေချင်ခဲ့တာ",
  "{name} WANTED YOU TO KNOW": "{name} က သင့်ကို သိစေချင်ခဲ့တာ",
  "React to this message": "ဒီစာကို တုံ့ပြန်ပါ",
  "SAY SOMETHING BACK": "ပြန်ပြောမယ်",
  "No read receipts. No thread. Just this moment.": "ဖတ်ပြီးကြောင်း မပြပါ။ ချတ်ဆက်တိုက် မရှိပါ။ ဒီ Moment တစ်ခုပဲ။",
  // Part C: connections and care
  "Played today": "ဒီနေ့ ကစားခဲ့တယ်",
  "Played yesterday": "မနေ့က ကစားခဲ့တယ်",
  "Played {count} days ago": "{count} ရက်အရင်က ကစားခဲ့တယ်",
  "Played last week": "ပြီးခဲ့တဲ့အပတ်က ကစားခဲ့တယ်",
  "Played {count} weeks ago": "{count} ပတ်အရင်က ကစားခဲ့တယ်",
  "ONCE": "တစ်ကြိမ်",
  "DAILY": "နေ့စဉ်",
  "HOURLY": "နာရီတိုင်း",
  "EVERY X HRS": "X နာရီတိုင်း",
  "WEEKLY": "အပတ်စဉ်",
  "MONTHLY": "လစဉ်",
  "YEARLY": "နှစ်စဉ်",
  "EVERY HOUR": "နာရီတိုင်း",
  "EVERY {count} HOURS": "{count} နာရီတိုင်း",
  "SELECTED DAYS": "ရွေးထားတဲ့ နေ့များ",
  "No future delivery": "နောက်ထပ် ပို့ရန် မရှိပါ",
  "MON": "တနင်္လာ",
  "TUE": "အင်္ဂါ",
  "WED": "ဗုဒ္ဓဟူး",
  "THU": "ကြာသပတေး",
  "FRI": "သောကြာ",
  "SAT": "စနေ",
  "SUN": "တနင်္ဂနွေ",
  "Could not open your connection.": "သင့်ချိတ်ဆက်မှုကို ဖွင့်လို့ မရပါ။",
  "Could not open your connections.": "သင့်ချိတ်ဆက်မှုများကို ဖွင့်လို့ မရပါ။",
  "Could not save that relationship.": "ဆက်ဆံရေးကို မသိမ်းနိုင်ပါ။",
  "Could not start another round.": "နောက်တစ်ပွဲ မစတင်နိုင်ပါ။",
  "Could not create that question.": "မေးခွန်းကို မဖန်တီးနိုင်ပါ။",
  "Could not send that question.": "မေးခွန်းကို မပို့နိုင်ပါ။",
  "Could not start SAY IT.": "SAY IT ကို မစတင်နိုင်ပါ။",
  "Could not leave that message for later.": "စာကို နောက်မှ ပို့ဖို့ မသိမ်းနိုင်ပါ။",
  "Could not cancel that Care message.": "Care စာကို ပယ်ဖျက်လို့ မရပါ။",
  "Could not change Care notifications.": "Care အသိပေးချက်ကို မပြောင်းနိုင်ပါ။",
  "Could not share this connection.": "ဒီချိတ်ဆက်မှုကို မမျှဝေနိုင်ပါ။",
  "Could not open your shared story.": "သင်တို့ရဲ့ ဇာတ်လမ်းကို ဖွင့်လို့ မရပါ။",
  "Remembering your people…": "သင့်လူတွေကို ပြန်မှတ်မိနေပါတယ်…",
  "People I’ve played with": "ကျွန်ုပ်နဲ့ ကစားဖူးတဲ့ လူများ",
  "Only humans you’ve actually met through UTAGE appear here.": "UTAGE မှာ တကယ်တွေ့ဖူးတဲ့ လူတွေသာ ဒီမှာ ပေါ်ပါမယ်။",
  "Your people will appear here after you play together.": "အတူကစားပြီးရင် သင့်လူတွေ ဒီမှာ ပေါ်လာပါမယ်။",
  "Connection unavailable.": "ချိတ်ဆက်မှုကို မရနိုင်ပါ။",
  "QUESTION READY": "မေးခွန်း အဆင်သင့်",
  "INVITE READY": "ဖိတ်ကြားချက် အဆင်သင့်",
  "Send it to {name}.": "{name} ဆီ ပို့လိုက်ပါ။",
  "Telegram couldn’t deliver this automatically. The invite is still only valid for {name}.": "Telegram က အလိုအလျောက် မပို့နိုင်ခဲ့ပါ။ ဒီဖိတ်ကြားချက်က {name} အတွက်သာ ဖြစ်ပါတယ်။",
  "You + {name}": "သင် + {name}",
  "OUR STORY": "ကျွန်ုပ်တို့ ဇာတ်လမ်း",
  "What your actual choices have started to show — nothing more.": "သင်တို့ တကယ်ရွေးခဲ့တာတွေက ပြသလာတာ — ဒါပဲ ဖြစ်ပါတယ်။",
  "STILL LEARNING": "လေ့လာဆဲ",
  "Not enough yet.": "အချက်အလက် မလုံလောက်သေးပါ။",
  "One answer never becomes a conclusion. Play together a little more and a pattern may emerge.": "အဖြေတစ်ခုတည်းနဲ့ ကောက်ချက်ချလို့ မရပါ။ နောက်ထပ် အတူကစားရင် ပုံစံတစ်ခု ပေါ်လာနိုင်ပါတယ်။",
  "SAME WAVELENGTH ON": "ဒီအကြောင်းတွေမှာ အတွေးတူတယ်",
  "Seen across several choices": "ရွေးချယ်မှု အများအပြားမှာ တွေ့ရတယ်",
  "A pattern may be emerging": "ပုံစံတစ်ခု ပေါ်လာနိုင်တယ်",
  "YOU APPROACH THIS DIFFERENTLY": "ဒီအကြောင်းကို မတူတဲ့ပုံစံနဲ့ ကြည့်ကြတယ်",
  "Mixed so far.": "အခုထိ ရောနှောနေတယ်။",
  "Your answers are revealing things, but UTAGE does not have a strong same-or-different pattern yet.": "သင်တို့ အဖြေတွေက တစ်ခုခုကို ပြသနေပေမယ့် တူတာ ဒါမှမဟုတ် မတူတာ ပုံစံ ခိုင်ခိုင်မာမာ မရှိသေးပါ။",
  "STILL MOSTLY UNEXPLORED": "အများစု မလေ့လာရသေးဘူး",
  "Same Brain choices can support pair patterns. Read Me predictions and Don’t Match strategy never become relationship conclusions.": "Same Brain ရွေးချယ်မှုတွေက ပုံစံတွေကို ပံ့ပိုးနိုင်ပါတယ်။ Read Me ခန့်မှန်းချက်နဲ့ Don’t Match နည်းဗျူဟာတွေကတော့ ဆက်ဆံရေးဆိုင်ရာ ကောက်ချက် ဘယ်တော့မှ မဖြစ်ပါ။",
  "For {name}": "{name} အတွက်",
  "SEND LATER": "နောက်မှ ပို့မယ်",
  "Write something human. UTAGE will carry it at the time you choose.": "စိတ်ရင်းနဲ့ တစ်ခုခု ရေးပါ။ သင်ရွေးတဲ့အချိန်မှာ UTAGE က ပို့ပေးပါမယ်။",
  "YOUR MESSAGE": "သင့်စာ",
  "Please drink some water and take care of yourself.": "ရေသောက်ပြီး ကိုယ့်ကိုယ်ကို ဂရုစိုက်ပါနော်။",
  "Care schedule": "Care အချိန်ဇယား",
  "Repeat interval": "ထပ်ပို့မယ့် အချိန်ကြား",
  "EVERY {count}H": "{count} နာရီတိုင်း",
  "DAYS": "နေ့များ",
  "Reminder days": "သတိပေးမယ့် နေ့များ",
  "START DATE": "စတင်မယ့်ရက်",
  "EVERY": "အကြိမ်",
  "1 hour": "၁ နာရီ",
  "{count} hours": "{count} နာရီ",
  "DAY START": "နေ့ စချိန်",
  "DAY END": "နေ့ ဆုံးချိန်",
  "SPECIAL DATE": "အထူးနေ့",
  "TIME": "အချိန်",
  "Timezone: {zone}.": "အချိန်ဇုန်: {zone}။",
  "Every hour from {start} to {end}. Quiet outside that window.": "{start} မှ {end} အထိ နာရီတိုင်း ပို့မယ်။ ဒီအချိန်ပြင်ပမှာ မပို့ပါ။",
  "Every {count} hours from {start} to {end}. Quiet outside that window.": "{start} မှ {end} အထိ {count} နာရီတိုင်း ပို့မယ်။ ဒီအချိန်ပြင်ပမှာ မပို့ပါ။",
  "Repeats every day at this local time.": "ဒီဒေသစံတော်ချိန်အတိုင်း နေ့တိုင်း ပို့မယ်။",
  "Repeats only on the selected days at this local time.": "ရွေးထားတဲ့ နေ့တွေမှာသာ ဒီအချိန် ပို့မယ်။",
  "Repeats every week on this weekday.": "ဒီနေ့ရက်မှာ အပတ်တိုင်း ပို့မယ်။",
  "Repeats every month on this date (month-end is handled safely).": "ဒီရက်စွဲမှာ လတိုင်း ပို့မယ် (လကုန်ရက်ကိုလည်း မှန်ကန်စွာ ကိုင်တွယ်ပါတယ်)။",
  "Repeats yearly on this special date.": "ဒီအထူးနေ့မှာ နှစ်တိုင်း ပို့မယ်။",
  "Sends once.": "တစ်ကြိမ်သာ ပို့မယ်။",
  "{active}/{limit} active for {name}. No read receipts or “ignored” status.": "{name} အတွက် {active}/{limit} ခု အသုံးပြုနေတယ်။ ဖတ်ပြီး ဒါမှမဟုတ် “လျစ်လျူရှု” အခြေအနေ မပြပါ။",
  "LEAVE THIS FOR LATER": "နောက်မှ ပို့ဖို့ ထားခဲ့မယ်",
  "Private to this connection. Both of you lock an answer before the reveal.": "ဒီချိတ်ဆက်မှုအတွက်သာ ဖြစ်ပါတယ်။ ရလဒ်မပြခင် နှစ်ယောက်လုံး အဖြေရွေးရပါမယ်။",
  "SENDING…": "ပို့နေပါတယ်…",
  "SEND TO {name}": "{name} ဆီ ပို့မယ်",
  "Ask {name}": "{name} ကို မေးမယ်",
  "MAKE A QUESTION": "မေးခွန်း ပြုလုပ်မယ်",
  "One short question. Two respectable choices. No chat thread after it.": "မေးခွန်းတိုတစ်ခု။ သင့်တော်တဲ့ ရွေးစရာ နှစ်ခု။ ပြီးရင် ချတ်ဆက်တိုက် မရှိပါ။",
  "On our next free day?": "နောက်အားလပ်ရက်မှာ?",
  "OPTION A": "ရွေးစရာ A",
  "Go somewhere": "တစ်နေရာရာ သွားမယ်",
  "OPTION B": "ရွေးစရာ B",
  "Stay home": "အိမ်မှာ နေမယ်",
  "Keep phone numbers, usernames, links, harassment, sexual content and threats out of custom questions.": "ဖုန်းနံပါတ်၊ username၊ link၊ နှောင့်ယှက်မှု၊ လိင်ပိုင်းဆိုင်ရာ အကြောင်းအရာနဲ့ ခြိမ်းခြောက်မှုတွေ မေးခွန်းထဲ မထည့်ပါနဲ့။",
  "CHECKING…": "စစ်ဆေးနေပါတယ်…",
  "PREVIEW QUESTION": "မေးခွန်းကို အရင်ကြည့်မယ်",
  "With {name}": "{name} နဲ့",
  "WHAT NOW?": "အခု ဘာလုပ်မလဲ?",
  "Make 10 questions and see how well people know you.": "မေးခွန်း ၁၀ ခု ပြုလုပ်ပြီး လူတွေ သင့်ကို ဘယ်လောက်သိလဲ ကြည့်ပါ။",
  "PEOPLE": "လူများ",
  "Someone you’ve actually played with.": "သင် တကယ် အတူကစားဖူးတဲ့သူ။",
  "REMEMBERING…": "ပြန်မှတ်မိနေပါတယ်…",
  "LEAVE SOMETHING": "တစ်ခုခု ထားခဲ့မယ်",
  "SAY IT": "SAY IT",
  "Shared UTAGE history": "အတူကစားခဲ့တဲ့ UTAGE မှတ်တမ်း",
  "games together": "ပွဲ အတူကစားခဲ့",
  "average /10": "ပျမ်းမျှ /10",
  "things explored": "ခု လေ့လာခဲ့",
  "Game averages": "ဂိမ်းအလိုက် ပျမ်းမျှ",
  "RECENT GAMES": "မကြာသေးမီ ဂိမ်းများ",
  "LEFT FOR LATER": "နောက်မှ ပို့ဖို့ ထားခဲ့တာ",
  "Couldn’t deliver yet — UTAGE will retry.": "မပို့နိုင်သေးပါ — UTAGE က ပြန်ကြိုးစားပါမယ်။",
  "by {name}": "{name} ရေးတာ",
  "CARE FROM {name}": "{name} ဆီက Care",
  "MUTED": "ပိတ်ထား",
  "ON": "ဖွင့်ထား",
  "Private to you. {name} won’t be told if you mute Care. Blocking them anywhere in UTAGE also stops future Care delivery.": "သင်တစ်ယောက်တည်းသာ မြင်ရပါတယ်။ Care ကို ပိတ်ထားရင် {name} ကို အသိပေးမှာ မဟုတ်ပါ။ UTAGE ထဲ ဘယ်နေရာမှာမဆို ပိတ်ဆို့လိုက်ရင်လည်း နောက်ထပ် Care မရောက်တော့ပါ။",
  "RELATIONSHIP · {label}": "ဆက်ဆံရေး · {label}",
  "ADD RELATIONSHIP": "ဆက်ဆံရေး ထည့်မယ်",
  "Private relationship label": "ကိုယ်ပိုင် ဆက်ဆံရေး အမည်",
  "REMOVE LABEL": "အမည် ဖယ်ရှားမယ်",
  "Private to you. UTAGE won’t announce this label to {name}.": "သင်တစ်ယောက်တည်းသာ မြင်ရပါတယ်။ UTAGE က ဒီအမည်ကို {name} ကို မပြောပါ။",
  "Wife": "ဇနီး",
  "Husband": "ခင်ပွန်း",
  "Partner": "ချစ်သူ",
  "Best Friend": "အခင်ဆုံး သူငယ်ချင်း",
  "Friend": "သူငယ်ချင်း",
  "Brother": "အစ်ကို/ညီ",
  "Sister": "အစ်မ/ညီမ",
  "Parent": "မိဘ",
  "Child": "သားသမီး",
  "Family": "မိသားစု",
  "Coworker": "လုပ်ဖော်ကိုင်ဖက်",
  // Part D: arcade hub and ludo
  "REMOTE 2P": "ဖုန်းနှစ်လုံး 2P",
  "MY TURN BEST": "အလှည့် အကောင်းဆုံး",
  "MY BEST": "အကောင်းဆုံး",
  "SEND TO RIVAL": "ပြိုင်ဘက်ဆီ ပို့မယ်",
  "{count} RUNS": "{count} ကြိမ်",
  "Could not open UTAGE Arcade.": "UTAGE Arcade ကို ဖွင့်လို့ မရပါ။",
  "Could not save this score.": "ဒီအမှတ်ကို မသိမ်းနိုင်ပါ။",
  "Challenge created, but Telegram sharing could not open. Try again.": "စိန်ခေါ်မှု ဖန်တီးပြီးပါပြီ၊ ဒါပေမဲ့ Telegram မျှဝေမှု မပွင့်ပါ။ ပြန်ကြိုးစားပါ။",
  "Could not create the challenge.": "စိန်ခေါ်မှု မဖန်တီးနိုင်ပါ။",
  "Loading the Arcade…": "Arcade ကို ဖွင့်နေပါတယ်…",
  "‹ ARCADE": "‹ ARCADE",
  "REMOTE DUEL": "အဝေးမှ ပြိုင်ပွဲ",
  "SAME RUN": "တူညီတဲ့ပွဲ",
  "BEAT {name} · {target}": "{name} ကို ကျော်ပါ · {target}",
  "Same seed. Same conditions. Your phone, your turn.": "တူညီတဲ့ပွဲ။ တူညီတဲ့ အခြေအနေ။ ကိုယ့်ဖုန်း၊ ကိုယ့်အလှည့်။",
  "YOUR CHALLENGE": "သင့်စိန်ခေါ်မှု",
  "BEATEN": "ကျော်သွားပြီ",
  "LIVE": "တိုက်ရိုက်",
  "{name} posted {score}.": "{name} က {score} မှတ် ရခဲ့တယ်။",
  "Waiting for a rival.": "ပြိုင်ဘက်ကို စောင့်နေပါတယ်။",
  "PLAY YOUR TURN": "ကိုယ့်အလှည့် ကစားမယ်",
  "Finish, then send this exact seeded turn to a friend.": "ကစားပြီးရင် ဒီပွဲအတိုင်း သူငယ်ချင်းဆီ ပို့ပါ။",
  "RUN {code} · BEST {best}": "ပွဲ {code} · အကောင်းဆုံး {best}",
  "TARGET {target}": "ပစ်မှတ် {target}",
  "RIVAL BEATEN": "ပြိုင်ဘက်ကို ကျော်ပြီ",
  "NEW RECORD": "စံချိန်သစ်",
  "TURN COMPLETE": "အလှည့် ပြီးပြီ",
  "RUN OVER": "ပွဲပြီးပြီ",
  "You beat {name}'s {target} on the same run.": "တူညီတဲ့ပွဲမှာ {name} ရဲ့ {target} မှတ်ကို ကျော်လိုက်ပြီ။",
  "{count} more to beat {name}.": "{name} ကို ကျော်ဖို့ နောက်ထပ် {count} မှတ် လိုသေးတယ်။",
  "Your turn is saved. Send this exact run to your rival.": "သင့်အလှည့်ကို သိမ်းထားပါပြီ။ ဒီပွဲအတိုင်း ပြိုင်ဘက်ဆီ ပို့ပါ။",
  "Personal best {score}": "ကိုယ့်အကောင်းဆုံး {score}",
  "TRY SAME RUN AGAIN": "ဒီပွဲကို ပြန်ကစားမယ်",
  "PLAY ANOTHER TURN": "နောက်တစ်လှည့် ကစားမယ်",
  "RUN IT AGAIN": "ထပ်ကစားမယ်",
  "SEND DUEL TO A FRIEND": "သူငယ်ချင်းဆီ ပြိုင်ပွဲ ပို့မယ်",
  "ALL GAMES": "ဂိမ်းအားလုံး",
  "ARCADE 2.2": "ARCADE 2.2",
  "PLAY SOMETHING.": "တစ်ခုခု ကစားကြမယ်။",
  "20 games.": "ဂိမ်း ၂၀။",
  "One rivalry.": "ပြိုင်ဘက် တစ်ယောက်။",
  "RUNS": "ကြိမ်",
  "RECORDS": "စံချိန်",
  "LIVE WITH FRIENDS · 2–8 PLAYERS": "သူငယ်ချင်းတွေနဲ့ တိုက်ရိုက် · ၂–၈ ယောက်",
  "UTAGE LUDO": "UTAGE LUDO",
  "One board. Everyone online. Take turns live.": "ဘုတ်တစ်ခု။ အားလုံး အွန်လိုင်း။ တိုက်ရိုက် အလှည့်ကျ ကစား။",
  "CREATE / JOIN LIVE ROOM →": "အခန်း ဖွင့် / ဝင် →",
  "TODAY'S PICK": "ဒီနေ့ ရွေးချယ်မှု",
  "PLAY NOW →": "အခု ကစားမယ် →",
  "BEST": "အကောင်းဆုံး",
  "QUICK SKILL": "အမြန် ကျွမ်းကျင်မှု",
  "Readable starts. Difficulty that keeps climbing.": "လွယ်လွယ်နဲ့ စတယ်။ တဖြည်းဖြည်း ခက်လာတယ်။",
  "PUZZLE + PRECISION": "ဉာဏ်စမ်း + တိကျမှု",
  "Simple rules. Multiple levels. Real mastery.": "စည်းမျဉ်း ရိုးရှင်းတယ်။ အဆင့်တွေ အများကြီး။ တကယ့် ကျွမ်းကျင်မှု။",
  "SPORT + AIM": "အားကစား + ချိန်ရွယ်",
  "Mobile-safe controls with no bottom-edge drag.": "ဖုန်းအောက်ခြေကို ဆွဲစရာမလိုတဲ့ ထိန်းချုပ်မှု။",
  "2 PLAYER · TWO PHONES": "၂ ယောက် · ဖုန်းနှစ်လုံး",
  "Play your turn, send it in Telegram, then settle the same seeded challenge.": "ကိုယ့်အလှည့် ကစားပြီး Telegram မှာ ပို့ပါ၊ ပြီးရင် တူညီတဲ့ပွဲနဲ့ အနိုင်အရှုံး ဆုံးဖြတ်ပါ။",
  "PLAY. SEND THE RUN. GET THE REMATCH.": "ကစား။ ပို့။ ပြန်ပြိုင်။",
  "Every challenge opens straight into the exact game on your friend's phone.": "စိန်ခေါ်မှုတိုင်းက သူငယ်ချင်းရဲ့ ဖုန်းမှာ အဲဒီဂိမ်းကို တိုက်ရိုက် ဖွင့်ပေးပါတယ်။",
  "AIM": "ချိန်ရွယ်",
  "ONE TAP": "တစ်ချက်နှိပ်",
  "RHYTHM": "စည်းချက်",
  "PRECISION": "တိကျမှု",
  "PUZZLE": "ဉာဏ်စမ်း",
  "REFLEX": "တုံ့ပြန်မှု",
  "SPORT": "အားကစား",
  "CLASSIC": "ဂန္ထဝင်",
  "ARCADE": "ARCADE",
  "COURSE COMPLETE": "ကွင်း ပြီးပြီ",
  "BOARD CLEARED": "ဘုတ် ရှင်းပြီ",
  "Flick. Swish. Keep climbing.": "ပစ်။ ဝင်။ ဆက်တက်။",
  "One tap. Don’t hit your own pins.": "တစ်ချက်နှိပ်။ ကိုယ့်ပင်ကို မထိပါစေနဲ့။",
  "Find the gap. Build the fire.": "ကွက်လပ်ကို ရှာ။ မီးတောက်အောင် ဆက်လုပ်။",
  "One tap. Learn the rhythm.": "တစ်ချက်နှိပ်။ စည်းချက်ကို လေ့လာ။",
  "Perfect the timing. Build higher.": "အချိန်ကိုက်အောင် လုပ်။ ပိုမြင့်အောင် တည်ဆောက်။",
  "Clear the board. Every arrow needs a way out.": "ဘုတ်ကို ရှင်းပါ။ မြှားတိုင်း ထွက်ပေါက် လိုတယ်။",
  "Tap to turn. Stay on the road.": "နှိပ်ပြီး လှည့်။ လမ်းပေါ်မှာ နေ။",
  "Switch lanes before traffic reaches you.": "ကားတွေ မရောက်ခင် လမ်းကြောင်း ပြောင်း။",
  "Hop forward. Dodge the traffic.": "ရှေ့ကို ခုန်။ ကားတွေကို ရှောင်။",
  "Swipe. Grow. Don’t hit yourself.": "ပွတ်ဆွဲ။ ကြီးထွား။ ကိုယ့်ကိုယ်ကို မတိုက်မိစေနဲ့။",
  "Watch the sequence. Repeat it.": "အစဉ်လိုက်ကို ကြည့်။ ပြန်လုပ်။",
  "Match the color before the gate hits.": "တံခါး မရောက်ခင် အရောင် ကိုက်အောင် လုပ်။",
  "Drag the paddle. Clear the wall.": "ဘတ်ကို ဆွဲ။ နံရံကို ရှင်း။",
  "Drag back. Sink five holes.": "နောက်ကို ဆွဲ။ တွင်း ငါးခု ဝင်အောင် လုပ်။",
  "Keep scoring until the keeper stops you three times.": "ဂိုးသမားက သုံးကြိမ် တားမချင်း ဆက်ဂိုးသွင်း။",
  "Swipe targets. Never touch a bomb.": "ပစ်မှတ်တွေကို ပွတ်ဆွဲ။ ဗုံးကို ဘယ်တော့မှ မထိနဲ့။",
  "Bounce higher. Tap to turn in air.": "ပိုမြင့်အောင် ခုန်။ လေထဲမှာ နှိပ်ပြီး လှည့်။",
  "Play your 45-second turn. Send the same run to a friend.": "စက္ကန့် ၄၅ အလှည့် ကစား။ တူညီတဲ့ပွဲကို သူငယ်ချင်းဆီ ပို့။",
  "Score goals in 45 seconds. Your rival gets the same serve pattern.": "စက္ကန့် ၄၅ အတွင်း ဂိုးသွင်း။ ပြိုင်ဘက်လည်း တူညီတဲ့ ပုံစံ ရမယ်။",
  "Seven reaction tests. Send the same delays to your rival.": "တုံ့ပြန်မှု စမ်းသပ်ချက် ခုနစ်ခု။ တူညီတဲ့ အချိန်တွေကို ပြိုင်ဘက်ဆီ ပို့။",
  "PLAYER": "ကစားသူ",
  "Extra roll!": "နောက်တစ်ကြိမ် ထပ်လှိမ့်ရမယ်!",
  "{name} goes first.": "{name} အရင် စမယ်။",
  "{name} ran out of time.": "{name} အချိန်ကုန်သွားတယ်။",
  "{name} rolled three sixes. Turn lost.": "{name} ခြောက် သုံးခါဆက် ကျလို့ အလှည့် ဆုံးရှုံးတယ်။",
  "{name} rolled {roll}. No legal move.": "{name} {roll} ကျတယ်။ ရွှေ့စရာ မရှိဘူး။",
  "{name} rolled {roll}.": "{name} {roll} ကျတယ်။",
  "{name} wins the room!": "{name} အနိုင်ရပြီ!",
  "{name} captured {count} piece.": "{name} အရုပ် {count} ခု စားလိုက်တယ်။",
  "{name} captured {count} pieces.": "{name} အရုပ် {count} ခု စားလိုက်တယ်။",
  "{name} brought a piece home.": "{name} အရုပ်တစ်ခု အိမ်ရောက်ပြီ။",
  "{name} moved piece {number}.": "{name} အရုပ် {number} ကို ရွှေ့လိုက်တယ်။",
  "UTAGE live Ludo board": "UTAGE တိုက်ရိုက် Ludo ဘုတ်",
  "LIVE LUDO": "တိုက်ရိုက် LUDO",
  "● LIVE": "● အွန်လိုင်း",
  "○ reconnecting": "○ ပြန်ချိတ်ဆက်နေ",
  "Could not open Ludo.": "Ludo ကို ဖွင့်လို့ မရပါ။",
  "Ludo action failed.": "Ludo လုပ်ဆောင်ချက် မအောင်မြင်ပါ။",
  "Could not create Ludo room.": "Ludo အခန်း မဖန်တီးနိုင်ပါ။",
  "Could not share this room.": "ဒီအခန်းကို မမျှဝေနိုင်ပါ။",
  "LIVE · 2–8 PLAYERS": "တိုက်ရိုက် · ၂–၈ ယောက်",
  "LIVE WITH FRIENDS": "သူငယ်ချင်းတွေနဲ့ တိုက်ရိုက်",
  "One board.": "ဘုတ်တစ်ခု။",
  "Eight phones.": "ဖုန်း ရှစ်လုံး။",
  "Create a private room, send it in Telegram, then everybody plays the same board live.": "ကိုယ်ပိုင်အခန်း ဖွင့်ပြီး Telegram မှာ ပို့ပါ၊ ပြီးရင် အားလုံး ဘုတ်တစ်ခုတည်းမှာ တိုက်ရိုက် ကစားကြမယ်။",
  "ROOM SIZE": "အခန်း အရွယ်အစား",
  "CREATING…": "ဖန်တီးနေပါတယ်…",
  "CREATE {count}-PLAYER ROOM": "{count} ယောက် အခန်း ဖွင့်မယ်",
  "🎲 Roll 6 to enter": "🎲 ၆ ကျမှ ဝင်ရမယ်",
  "✦ Capture rivals": "✦ ပြိုင်ဘက်ကို စား",
  "⌂ Bring all 4 home": "⌂ ၄ ခုလုံး အိမ်ပို့",
  "⚡ Live turns + reconnect": "⚡ တိုက်ရိုက်အလှည့် + ပြန်ချိတ်ဆက်",
  "Opening live Ludo…": "Ludo ကို ဖွင့်နေပါတယ်…",
  "‹ HOME": "‹ ပင်မ",
  "{count}/{max} JOINED": "{count}/{max} ဝင်ပြီး",
  "OFFLINE": "အော့ဖ်လိုင်း",
  "PRIVATE LIVE ROOM": "ကိုယ်ပိုင် တိုက်ရိုက်အခန်း",
  "{count}/{max} players": "ကစားသူ {count}/{max}",
  "Join now. The host starts when everybody is ready.": "အခုဝင်ပါ။ အားလုံး အဆင်သင့်ဖြစ်ရင် အခန်းရှင်က စပါမယ်။",
  "This room is full.": "ဒီအခန်း ပြည့်သွားပါပြီ။",
  "This room already started.": "ဒီအခန်း စတင်ပြီးပါပြီ။",
  "ROOM FULL": "အခန်း ပြည့်ပြီ",
  "JOIN LIVE GAME": "ဂိမ်းထဲ ဝင်မယ်",
  "GAME STARTED": "ဂိမ်း စပြီ",
  "ROOM CLOSED": "အခန်း ပိတ်ပြီ",
  "ROOM EXPIRED": "အခန်း သက်တမ်းကုန်ပြီ",
  "ROOM CANCELLED": "အခန်း ပယ်ဖျက်ပြီ",
  "This table is closed.": "ဒီဘုတ် ပိတ်သွားပါပြီ။",
  "Create another live room from the Arcade.": "Arcade ကနေ အခန်းအသစ် ဖွင့်ပါ။",
  "BACK TO ARCADE": "ARCADE သို့ ပြန်မယ်",
  "LOBBY · {count}/{max}": "စောင့်ခန်း · {count}/{max}",
  "ROOM OPEN": "အခန်း ပွင့်နေပြီ",
  "Get everyone in.": "အားလုံးကို ခေါ်ပါ။",
  "Each person joins from their own Telegram. When everybody is ready, the host starts the board.": "တစ်ယောက်ချင်းစီ ကိုယ့် Telegram ကနေ ဝင်ပါ။ အားလုံး အဆင်သင့်ဖြစ်ရင် အခန်းရှင်က စပါမယ်။",
  "SHARE ROOM": "အခန်း မျှဝေမယ်",
  "PLAYER {number}": "ကစားသူ {number}",
  "READY": "အဆင်သင့်",
  "OPEN SEAT": "နေရာလွတ်",
  "START LIVE GAME": "ဂိမ်း စမယ်",
  "WAITING FOR READY": "အဆင်သင့်ဖြစ်ဖို့ စောင့်နေ",
  "Could not leave room.": "အခန်းက မထွက်နိုင်ပါ။",
  "LEAVE ROOM": "အခန်းက ထွက်မယ်",
  "{count} PLAYERS · LIVE": "ကစားသူ {count} ယောက် · တိုက်ရိုက်",
  "WINNER": "အနိုင်ရသူ",
  "GAME OVER": "ဂိမ်း ပြီးပြီ",
  "All four pieces made it home first.": "အရုပ် လေးခုလုံး အရင်ဆုံး အိမ်ရောက်ခဲ့တယ်။",
  "FINAL": "နောက်ဆုံး",
  "YOUR TURN": "သင့်အလှည့်",
  "{name}'S TURN": "{name} ရဲ့ အလှည့်",
  "Game started.": "ဂိမ်း စပြီ။",
  "{seconds}s left": "{seconds} စက္ကန့် ကျန်",
  "rolled {roll}": "{roll} ကျတယ်",
  "waiting for roll": "အံစာတုံး လှိမ့်ဖို့ စောင့်နေ",
  "ROLLING": "လှိမ့်နေတယ်",
  "ROLL DICE": "အံစာတုံး လှိမ့်မယ်",
  "MOVE A HIGHLIGHTED PIECE": "အလင်းပြထားတဲ့ အရုပ်ကို ရွှေ့ပါ",
  "PIECE {number}": "အရုပ် {number}",
  "WATCHING LIVE": "တိုက်ရိုက် ကြည့်နေ",
  "{name} is playing…": "{name} ကစားနေတယ်…",
  "{count}/4 HOME": "{count}/4 အိမ်ရောက်",
  "SHARE ROOM LINK": "အခန်း link မျှဝေမယ်",
  // Ludo return
  "RETURN TO LIVE GAME →": "ဂိမ်းထဲ ပြန်ဝင်မယ် →",
  // Theme
  "APPEARANCE": "အသွင်အပြင်",
  "☀ LIGHT": "☀ အလင်း",
  "☾ DARK": "☾ အမှောင်",
  // Server messages shown to players (translated in ApiError)
  "Please update UTAGE and try again.": "UTAGE ကို အပ်ဒိတ်လုပ်ပြီး ပြန်ကြိုးစားပါ။",
  "This Ludo room does not exist.": "ဒီ Ludo အခန်း မရှိပါ။",
  "This Ludo room has no active players.": "ဒီ Ludo အခန်းမှာ ကစားသူ မရှိပါ။",
  "Use a new action ID.": "ပြန်ကြိုးစားပါ။",
  "Live game invitations are unavailable for this account.": "ဒီအကောင့်အတွက် တိုက်ရိုက်ဂိမ်း ဖိတ်ကြားချက် မရနိုင်ပါ။",
  "Choose between 2 and 8 players.": "ကစားသူ ၂ ယောက်မှ ၈ ယောက်အထိ ရွေးပါ။",
  "This Ludo game has already started.": "ဒီ Ludo ဂိမ်း စတင်ပြီးပါပြီ။",
  "You already left this lobby.": "ဒီစောင့်ခန်းက ထွက်ပြီးပါပြီ။",
  "This Ludo room is full.": "ဒီ Ludo အခန်း ပြည့်သွားပါပြီ။",
  "Join this Ludo room first.": "ဒီ Ludo အခန်းထဲ အရင်ဝင်ပါ။",
  "Only the host can start this game.": "အခန်းရှင်သာ ဂိမ်းကို စနိုင်ပါတယ်။",
  "At least two players must join and everybody must be ready.": "အနည်းဆုံး ကစားသူ နှစ်ယောက် ဝင်ပြီး အားလုံး အဆင်သင့် ဖြစ်ရပါမယ်။",
  "This Ludo game is not active.": "ဒီ Ludo ဂိမ်း လက်ရှိ ကစားနေတာ မဟုတ်ပါ။",
  "Wait for your turn.": "သင့်အလှည့်ကို စောင့်ပါ။",
  "Move one of the highlighted pieces first.": "အလင်းပြထားတဲ့ အရုပ်တစ်ခုကို အရင်ရွှေ့ပါ။",
  "Roll the dice first.": "အံစာတုံးကို အရင်လှိမ့်ပါ။",
  "Choose a valid piece.": "ရွှေ့လို့ရတဲ့ အရုပ်ကို ရွေးပါ။",
  "That piece cannot move with this roll.": "ဒီအရုပ်က ဒီအကြိမ်ကျတာနဲ့ ရွှေ့လို့ မရပါ။",
  "Only the host can cancel this room.": "အခန်းရှင်သာ ဒီအခန်းကို ပယ်ဖျက်နိုင်ပါတယ်။",
  "This Ludo game is already complete.": "ဒီ Ludo ဂိမ်း ပြီးဆုံးသွားပါပြီ။",
  "A live Ludo game stays intact; close UTAGE and reconnect when you return.": "တိုက်ရိုက် Ludo ဂိမ်းကို ဆက်ထားပါမယ်။ UTAGE ကို ပိတ်ပြီး ပြန်လာတဲ့အခါ ပြန်ဝင်ပါ။",
  "Cancel the room if you want to close it.": "အခန်းကို ပိတ်ချင်ရင် ပယ်ဖျက်ပါ။",
  "Open UTAGE from Telegram.": "Telegram ထဲကနေ UTAGE ကို ဖွင့်ပါ။",
  "This account cannot use UTAGE.": "ဒီအကောင့်က UTAGE ကို သုံးလို့ မရပါ။",
  "This UTAGE profile does not exist.": "ဒီ UTAGE ပရိုဖိုင် မရှိပါ။",
  "Use between 1 and 40 characters for your UTAGE name.": "UTAGE နာမည်ကို စာလုံး ၁ လုံးမှ ၄၀ အထိ သုံးပါ။",
  "Use a JPEG, PNG or WebP profile photo.": "JPEG၊ PNG ဒါမှမဟုတ် WebP ပရိုဖိုင်ဓာတ်ပုံ သုံးပါ။",
  "Keep your UTAGE profile photo under 192 KB.": "ပရိုဖိုင်ဓာတ်ပုံကို 192 KB အောက် ထားပါ။",
  "This profile photo is unavailable.": "ဒီပရိုဖိုင်ဓာတ်ပုံ မရနိုင်ပါ။",
  "Too many attempts. Try again shortly.": "ကြိုးစားမှု များလွန်းနေပါတယ်။ ခဏနေမှ ပြန်ကြိုးစားပါ။",
  "That route does not exist.": "ဒီစာမျက်နှာ မရှိပါ။",
  "This SAY IT moment does not exist.": "ဒီ SAY IT မရှိပါ။",
  "This SAY IT moment is unavailable.": "ဒီ SAY IT မရနိုင်ပါ။",
  "Only the invited person can accept this moment.": "ဖိတ်ခံရသူသာ ဒီ Moment ကို လက်ခံနိုင်ပါတယ်။",
  "This moment is no longer waiting for consent.": "ဒီ Moment က သဘောတူညီချက် စောင့်နေတာ မဟုတ်တော့ပါ။",
  "Only the invited person can choose to keep it light.": "ဖိတ်ခံရသူသာ ပေါ့ပေါ့ပါးပါး ထားဖို့ ရွေးနိုင်ပါတယ်။",
  "Only the sender can cancel this moment.": "ပို့သူသာ ဒီ Moment ကို ပယ်ဖျက်နိုင်ပါတယ်။",
  "This moment cannot be cancelled now.": "ဒီ Moment ကို အခု ပယ်ဖျက်လို့ မရပါ။",
  "Only the sender can write this response.": "ပို့သူသာ ဒီအဖြေကို ရေးနိုင်ပါတယ်။",
  "Wait until the other person chooses to go deeper.": "တစ်ဖက်လူက ပိုနက်နက် သွားဖို့ ရွေးတဲ့အထိ စောင့်ပါ။",
  "Only the recipient can react to this message.": "လက်ခံသူသာ ဒီစာကို တုံ့ပြန်နိုင်ပါတယ်။",
  "There is nothing to react to yet.": "တုံ့ပြန်စရာ မရှိသေးပါ။",
  "Choose a reaction.": "တုံ့ပြန်မှုတစ်ခု ရွေးပါ။",
  "You already reacted to this moment.": "ဒီ Moment ကို တုံ့ပြန်ပြီးပါပြီ။",
  "Keep the question and all four answers filled in.": "မေးခွန်းနဲ့ အဖြေလေးခုလုံးကို ဖြည့်ထားပါ။",
  "Use four different answers.": "မတူညီတဲ့ အဖြေ လေးခု သုံးပါ။",
  "Remove links, contact details or unsafe content from this quiz question.": "ဒီမေးခွန်းထဲက link၊ ဆက်သွယ်ရန် အချက်အလက် ဒါမှမဟုတ် မသင့်တော်တဲ့ အကြောင်းအရာကို ဖယ်ရှားပါ။",
  "This quiz does not exist.": "ဒီမေးခွန်းဂိမ်း မရှိပါ။",
  "Only the quiz creator can change this card.": "ဖန်တီးသူသာ ဒီမေးခွန်းဂိမ်းကို ပြင်နိုင်ပါတယ်။",
  "UTAGE needs a few more unseen questions before making this quiz.": "ဒီမေးခွန်းဂိမ်း ပြုလုပ်ဖို့ UTAGE မှာ မမြင်ရသေးတဲ့ မေးခွန်း နည်းနည်း ထပ်လိုပါသေးတယ်။",
  "Give this quiz a short title.": "ဒီမေးခွန်းဂိမ်းကို ခေါင်းစဉ်တိုတို ပေးပါ။",
  "Published quizzes stay fixed so old results remain meaningful.": "တင်ပြီးသား မေးခွန်းဂိမ်းကို ယခင်ရလဒ်တွေ အဓိပ္ပာယ်ရှိနေစေဖို့ မပြောင်းနိုင်ပါ။",
  "Only Custom Quiz questions can be edited.": "ကိုယ်ပိုင် မေးခွန်းဂိမ်းရဲ့ မေးခွန်းတွေကိုသာ ပြင်နိုင်ပါတယ်။",
  "This quiz question does not exist.": "ဒီမေးခွန်း မရှိပါ။",
  "This quiz is archived.": "ဒီမေးခွန်းဂိမ်းကို သိမ်းဆည်းထားပြီးပါပြီ။",
  "Choose your answer for all 10 questions before sharing.": "မမျှဝေခင် မေးခွန်း ၁၀ ခုလုံးအတွက် အဖြေ ရွေးပါ။",
  "Share this quiz with someone else.": "ဒီမေးခွန်းဂိမ်းကို တခြားတစ်ယောက်နဲ့ မျှဝေပါ။",
  "This quiz is unavailable.": "ဒီမေးခွန်းဂိမ်း မရနိုင်ပါ။",
  "This quiz is not ready.": "ဒီမေးခွန်းဂိမ်း အဆင်သင့် မဖြစ်သေးပါ။",
  "Answer all 10 questions before finishing.": "မပြီးခင် မေးခွန်း ၁၀ ခုလုံး ဖြေပါ။",
  "Each quiz question needs one answer.": "မေးခွန်းတိုင်းအတွက် အဖြေတစ်ခု လိုပါတယ်။",
  "Refresh this quiz and try again.": "ဒီမေးခွန်းဂိမ်းကို ပြန်ဖွင့်ပြီး ပြန်ကြိုးစားပါ။",
  "That quiz result is unavailable.": "ဒီရလဒ် မရနိုင်ပါ။",
  "Use a JPEG, PNG or WebP image.": "JPEG၊ PNG ဒါမှမဟုတ် WebP ပုံ သုံးပါ။",
  "Keep quiz choice pictures under 256 KB.": "ရွေးစရာပုံတွေကို 256 KB အောက် ထားပါ။",
  "That file does not look like the selected image type.": "ဒီဖိုင်က ရွေးထားတဲ့ ပုံအမျိုးအစားနဲ့ မကိုက်ညီပါ။",
  "Pictures can only be changed while editing a Custom Quiz.": "ကိုယ်ပိုင် မေးခွန်းဂိမ်း ပြင်နေချိန်မှာသာ ပုံပြောင်းနိုင်ပါတယ်။",
  "Published quizzes stay fixed.": "တင်ပြီးသား မေးခွန်းဂိမ်းကို မပြောင်းနိုင်ပါ။",
  "This quiz image is unavailable.": "ဒီပုံ မရနိုင်ပါ။",
  "This custom picture is unavailable.": "ဒီကိုယ်ပိုင်ပုံ မရနိုင်ပါ။",
  "This person is not an available UTAGE connection.": "ဒီလူက သင့် UTAGE ချိတ်ဆက်မှုထဲ မရှိပါ။",
  "That question is not available.": "ဒီမေးခွန်း မရနိုင်ပါ။",
  "Only the person who made this unsaved question can send it.": "ဒီမေးခွန်းကို ရေးသူသာ ပို့နိုင်ပါတယ်။",
  "Only the person who made this question can save it for the pair.": "ဒီမေးခွန်းကို ရေးသူသာ နှစ်ယောက်အတွက် သိမ်းနိုင်ပါတယ်။",
  "Play this question together before saving it for the pair.": "မသိမ်းခင် ဒီမေးခွန်းကို အတူ ကစားကြည့်ပါ။",
  "This custom question is no longer available.": "ဒီကိုယ်ပိုင်မေးခွန်း မရနိုင်တော့ပါ။",
  "A custom question needs exactly two people.": "ကိုယ်ပိုင်မေးခွန်းအတွက် လူနှစ်ယောက် အတိအကျ လိုပါတယ်။",
  "Choose another person.": "တခြားတစ်ယောက်ကို ရွေးပါ။",
  "Safety actions are available for people you encountered in UTAGE.": "UTAGE မှာ တွေ့ဖူးတဲ့သူတွေအတွက်သာ လုံခြုံရေး လုပ်ဆောင်ချက်တွေ သုံးနိုင်ပါတယ်။",
  "Too many safety changes. Try again later.": "လုံခြုံရေး ပြောင်းလဲမှု များလွန်းနေပါတယ်။ နောက်မှ ပြန်ကြိုးစားပါ။",
  "Too many reports. Try again later.": "တိုင်ကြားမှု များလွန်းနေပါတယ်။ နောက်မှ ပြန်ကြိုးစားပါ။",
  "This person cannot receive a UTAGE invite right now.": "ဒီလူကို အခု UTAGE ဖိတ်ကြားချက် ပို့လို့ မရပါ။",
  "Telegram authorization expired. Reopen UTAGE.": "Telegram ခွင့်ပြုချက် သက်တမ်းကုန်သွားပါပြီ။ UTAGE ကို ပြန်ဖွင့်ပါ။",
  "This UTAGE session does not exist.": "ဒီဂိမ်း မရှိပါ။",
  "You are not part of this UTAGE session.": "သင်က ဒီဂိမ်းထဲ မပါဝင်ပါ။",
  "This UTAGE session has expired.": "ဒီဂိမ်း သက်တမ်းကုန်သွားပါပြီ။",
  "This UTAGE session already has two people.": "ဒီဂိမ်းမှာ လူနှစ်ယောက် ပြည့်နေပါပြီ။",
  "This UTAGE session is unavailable.": "ဒီဂိမ်း မရနိုင်ပါ။",
  "Session changed. Refreshing the latest state.": "ဂိမ်း ပြောင်းလဲသွားပါတယ်။ နောက်ဆုံးအခြေအနေကို ပြန်ဖွင့်နေပါတယ်။",
  "This game has ended.": "ဒီဂိမ်း ပြီးဆုံးသွားပါပြီ။",
  "Replay saved custom questions from the connection page.": "သိမ်းထားတဲ့ ကိုယ်ပိုင်မေးခွန်းတွေကို ချိတ်ဆက်မှု စာမျက်နှာကနေ ပြန်ကစားပါ။",
  "Finish this session before requesting a rematch.": "ပြန်ကစားဖို့ မတောင်းခင် ဒီဂိမ်းကို ပြီးအောင် ကစားပါ။",
  "A rematch is unavailable.": "ပြန်ကစားလို့ မရနိုင်ပါ။",
  "Someone New is unavailable for this account.": "ဒီအကောင့်အတွက် လူသစ်နဲ့ ကစားခြင်း မရနိုင်ပါ။",
  "This UTAGE user does not exist.": "ဒီ UTAGE အသုံးပြုသူ မရှိပါ။",
  "UTAGE could not prepare the next question. Please try again.": "UTAGE က နောက်မေးခွန်းကို မပြင်ဆင်နိုင်ပါ။ ပြန်ကြိုးစားပါ။",
  "This group has explored every fresh question available in this bank.": "ဒီအဖွဲ့က ရနိုင်တဲ့ မေးခွန်းအသစ် အားလုံးကို ကစားပြီးပါပြီ။",
  "This quiz replay does not exist.": "ဒီ Replay မရှိပါ။",
  "Only the person who took this quiz can make this replay.": "ဒီမေးခွန်းဂိမ်းကို ဖြေသူသာ ဒီ Replay ကို ပြုလုပ်နိုင်ပါတယ်။",
  "This quiz result is not complete enough for a replay.": "ဒီရလဒ်က Replay အတွက် မပြည့်စုံသေးပါ။",
  "This quiz replay download link is no longer valid.": "ဒီ Replay ဒေါင်းလုဒ် link မသုံးနိုင်တော့ပါ။",
  "This quiz replay download link expired. Make a new one.": "ဒီ Replay ဒေါင်းလုဒ် link သက်တမ်းကုန်သွားပါပြီ။ အသစ်ပြုလုပ်ပါ။",
  "This UTAGE game does not exist.": "ဒီ UTAGE ဂိမ်း မရှိပါ။",
  "Only the people in this game can open its replay.": "ဒီဂိမ်းထဲက လူတွေသာ Replay ကို ဖွင့်နိုင်ပါတယ်။",
  "Finish this game before making a replay.": "Replay မပြုလုပ်ခင် ဒီဂိမ်းကို ပြီးအောင် ကစားပါ။",
  "Game Replay currently supports completed Friend games.": "ဂိမ်း Replay က ပြီးဆုံးသွားတဲ့ သူငယ်ချင်းဂိမ်းတွေအတွက်သာ ရပါသေးတယ်။",
  "This replay needs both players.": "ဒီ Replay အတွက် ကစားသူနှစ်ယောက်လုံး လိုပါတယ်။",
  "A replay profile is unavailable.": "Replay ပရိုဖိုင် မရနိုင်ပါ။",
  "Could not finish this replay yet. Try again in a moment.": "ဒီ Replay ကို မပြီးဆုံးနိုင်သေးပါ။ ခဏနေမှ ပြန်ကြိုးစားပါ။",
  "Could not make this replay yet. Try again in a moment.": "ဒီ Replay ကို မပြုလုပ်နိုင်သေးပါ။ ခဏနေမှ ပြန်ကြိုးစားပါ။",
  "This replay download link is no longer valid.": "ဒီ Replay ဒေါင်းလုဒ် link မသုံးနိုင်တော့ပါ။",
  "This replay download link expired. Make a new one.": "ဒီ Replay ဒေါင်းလုဒ် link သက်တမ်းကုန်သွားပါပြီ။ အသစ်ပြုလုပ်ပါ။",
  "Could not make this quiz replay yet. Try again in a moment.": "ဒီမေးခွန်းဂိမ်း Replay ကို မပြုလုပ်နိုင်သေးပါ။ ခဏနေမှ ပြန်ကြိုးစားပါ။",
  "Choose a valid timezone.": "မှန်ကန်တဲ့ အချိန်ဇုန်ကို ရွေးပါ။",
  "Choose a valid date.": "မှန်ကန်တဲ့ ရက်စွဲကို ရွေးပါ။",
  "Choose a valid time.": "မှန်ကန်တဲ့ အချိန်ကို ရွေးပါ။",
  "Choose valid days of the week.": "မှန်ကန်တဲ့ နေ့တွေကို ရွေးပါ။",
  "That local time does not exist in this timezone. Choose another time.": "ဒီအချိန်ဇုန်မှာ ဒီအချိန် မရှိပါ။ တခြားအချိန် ရွေးပါ။",
  "Selected weekdays are available for daily and daytime repeating reminders.": "နေ့ရွေးချယ်ခြင်းကို နေ့စဉ်နဲ့ နေ့အတွင်း ထပ်ပို့တဲ့ သတိပေးချက်တွေအတွက်သာ သုံးနိုင်ပါတယ်။",
  "Choose 1, 2, 3, 4, 6 or 12 hours.": "၁၊ ၂၊ ၃၊ ၄၊ ၆ ဒါမှမဟုတ် ၁၂ နာရီ ရွေးပါ။",
  "Day end must be after day start.": "နေ့ဆုံးချိန်က နေ့စချိန်ထက် နောက်ကျရပါမယ်။",
  "Start the reminder inside the daytime window.": "သတိပေးချက်ကို နေ့အချိန်အတွင်း စတင်ပါ။",
  "Choose a date within the next 10 years.": "နောက် ၁၀ နှစ်အတွင်း ရက်စွဲတစ်ခု ရွေးပါ။",
  "Choose a time at least one minute from now.": "အခုကနေ အနည်းဆုံး တစ်မိနစ် နောက်ကျတဲ့ အချိန်ကို ရွေးပါ။",
  "Care is unavailable for this connection.": "ဒီချိတ်ဆက်မှုအတွက် Care မရနိုင်ပါ။",
  "That Care message is no longer available.": "ဒီ Care စာ မရနိုင်တော့ပါ။",
  "This Arcade challenge does not exist.": "ဒီ Arcade စိန်ခေါ်မှု မရှိပါ။",
  "This Arcade run is missing a valid seed.": "ဒီပွဲမှာ အချက်အလက် မပြည့်စုံပါ။ ပြန်ကစားပါ။",
  "This Arcade run duration is invalid.": "ဒီပွဲရဲ့ ကြာချိန် မမှန်ကန်ပါ။",
  "That Arcade score is outside the accepted range.": "ဒီအမှတ်က လက်ခံနိုင်တဲ့ အတိုင်းအတာ ပြင်ပ ဖြစ်နေပါတယ်။",
  "This challenge belongs to another game.": "ဒီစိန်ခေါ်မှုက တခြားဂိမ်းအတွက် ဖြစ်ပါတယ်။",
  "Restart this challenge so both players get the same run.": "ကစားသူနှစ်ယောက်လုံး တူညီတဲ့ပွဲ ရဖို့ ဒီစိန်ခေါ်မှုကို ပြန်စပါ။",
  "Share this score with a friend.": "ဒီအမှတ်ကို သူငယ်ချင်းနဲ့ မျှဝေပါ။",
  "This Arcade challenge has closed.": "ဒီ Arcade စိန်ခေါ်မှု ပိတ်သွားပါပြီ။",
  "Another player already accepted this challenge.": "တခြားကစားသူတစ်ယောက် ဒီစိန်ခေါ်မှုကို လက်ခံပြီးပါပြီ။",
  "This Arcade game does not support friend challenges.": "ဒီ Arcade ဂိမ်းမှာ သူငယ်ချင်းစိန်ခေါ်မှု မရနိုင်ပါ။",
  "Score at least 1 point before challenging a friend.": "သူငယ်ချင်းကို မစိန်ခေါ်ခင် အနည်းဆုံး ၁ မှတ် ရအောင် ကစားပါ။",
  "Finish that exact run before challenging a friend.": "သူငယ်ချင်းကို မစိန်ခေါ်ခင် ဒီပွဲကို ပြီးအောင် ကစားပါ။",
  "This group room does not exist.": "ဒီအဖွဲ့အခန်း မရှိပါ။",
  "Group invitations are unavailable for this account.": "ဒီအကောင့်အတွက် အဖွဲ့ဖိတ်ကြားချက် မရနိုင်ပါ။",
  "This group room expired.": "ဒီအဖွဲ့အခန်း သက်တမ်းကုန်သွားပါပြီ။",
  "This group room was cancelled.": "ဒီအဖွဲ့အခန်းကို ပယ်ဖျက်လိုက်ပါပြီ။",
  "This group room has already started.": "ဒီအဖွဲ့ဂိမ်း စတင်ပြီးပါပြီ။",
  "This group room is unavailable.": "ဒီအဖွဲ့အခန်း မရနိုင်ပါ။",
  "This group room is full.": "ဒီအဖွဲ့အခန်း ပြည့်သွားပါပြီ။",
  "Join this group room first.": "ဒီအဖွဲ့အခန်းထဲ အရင်ဝင်ပါ။",
  "Only the host can start this group.": "အခန်းရှင်သာ ဒီအဖွဲ့ဂိမ်းကို စနိုင်ပါတယ်။",
  "This group room cannot start now.": "ဒီအဖွဲ့ဂိမ်းကို အခု မစနိုင်ပါ။",
  "Open a fresh group before starting.": "မစခင် အဖွဲ့အသစ်တစ်ခု ဖွင့်ပါ။",
  "Only the host can move the group forward.": "အခန်းရှင်သာ အဖွဲ့ဂိမ်းကို ဆက်သွားနိုင်ပါတယ်။",
  "Only the host can cancel this group.": "အခန်းရှင်သာ ဒီအဖွဲ့ကို ပယ်ဖျက်နိုင်ပါတယ်။",
  "The host can cancel the room instead.": "အခန်းရှင်က အခန်းကို ပယ်ဖျက်နိုင်ပါတယ်။",
  "This group round is not ready yet.": "ဒီအချီ အဆင်သင့် မဖြစ်သေးပါ။",
  "This group game is not accepting answers.": "ဒီအဖွဲ့ဂိမ်းက အဖြေ လက်မခံတော့ပါ။",
  "This group round has already revealed.": "ဒီအချီရဲ့ ရလဒ်ကို ပြပြီးပါပြီ။",
  "You are not part of this group.": "သင်က ဒီအဖွဲ့ထဲ မပါဝင်ပါ။",
  "Reactions open after everyone reveals.": "အားလုံးရဲ့ ရလဒ်ပြပြီးမှ တုံ့ပြန်လို့ ရပါမယ်။",
  "This group game is complete.": "ဒီအဖွဲ့ဂိမ်း ပြီးဆုံးသွားပါပြီ။",
  "Everyone must lock before continuing.": "ဆက်မသွားခင် အားလုံး အဖြေရွေးရပါမယ်။",
  "This challenge does not exist.": "ဒီစိန်ခေါ်မှု မရှိပါ။",
  "That Moment is not compatible with this interaction.": "ဒီ Moment က ဒီဂိမ်းပုံစံနဲ့ မကိုက်ညီပါ။",
  "Friend challenges are unavailable for this account.": "ဒီအကောင့်အတွက် သူငယ်ချင်းစိန်ခေါ်မှု မရနိုင်ပါ။",
  "This challenge is unavailable.": "ဒီစိန်ခေါ်မှု မရနိုင်ပါ။",
  "Share this challenge with a friend.": "ဒီစိန်ခေါ်မှုကို သူငယ်ချင်းနဲ့ မျှဝေပါ။",
  "This challenge has expired.": "ဒီစိန်ခေါ်မှု သက်တမ်းကုန်သွားပါပြီ။",
  "This challenge has already started.": "ဒီစိန်ခေါ်မှု စတင်ပြီးပါပြီ။",
  "Only the sender can cancel this challenge.": "ပို့သူသာ ဒီစိန်ခေါ်မှုကို ပယ်ဖျက်နိုင်ပါတယ်။",
  "That answer is not available for this round.": "ဒီအဖြေက ဒီအချီအတွက် မရနိုင်ပါ။",
  "This round is not ready yet.": "ဒီအချီ အဆင်သင့် မဖြစ်သေးပါ။",
  "That answer is not available for you in this round.": "ဒီအဖြေက ဒီအချီမှာ သင့်အတွက် မရနိုင်ပါ။",
  "This round has already revealed.": "ဒီအချီရဲ့ ရလဒ်ကို ပြပြီးပါပြီ။",
  "Reactions open after the reveal.": "ရလဒ်ပြပြီးမှ တုံ့ပြန်လို့ ရပါမယ်။",
  "A custom question is one reveal.": "ကိုယ်ပိုင်မေးခွန်းမှာ ရလဒ်တစ်ကြိမ်သာ ရှိပါတယ်။",
  "Both people must lock before continuing.": "ဆက်မသွားခင် နှစ်ယောက်လုံး အဖြေရွေးရပါမယ်။",
  "This pair session is complete.": "ဒီဂိမ်း ပြီးဆုံးသွားပါပြီ။",
  "Could not prepare a quiz replay download yet.": "Replay ဒေါင်းလုဒ်ကို မပြင်ဆင်နိုင်သေးပါ။",
  "Could not prepare a download link yet.": "ဒေါင်းလုဒ် link ကို မပြင်ဆင်နိုင်သေးပါ။",
  "Something went wrong.": "တစ်ခုခု မှားယွင်းသွားပါတယ်။",
  "The request was not valid.": "တောင်းဆိုမှု မမှန်ကန်ပါ။",
  // Client error fallbacks
  "You already have the most Care messages allowed for this person.": "ဒီလူအတွက် Care စာ အများဆုံး ထားပြီးပါပြီ။",
  "More people need to join and be ready first.": "နောက်ထပ် လူတွေ ဝင်ပြီး အဆင်သင့် ဖြစ်ဖို့ လိုပါသေးတယ်။",
  "Every round must be revealed for a full replay.": "Replay အပြည့်အစုံအတွက် အချီတိုင်းရဲ့ ရလဒ်ကို ပြပြီးရပါမယ်။",
  "This game cannot do that right now.": "ဒီဂိမ်းမှာ အခု ဒါကို လုပ်လို့ မရပါ။",
  "Could not start UTAGE.": "UTAGE ကို မစတင်နိုင်ပါ။",
  "Arcade request failed.": "Arcade လုပ်ဆောင်ချက် မအောင်မြင်ပါ။",
  "Could not update Care.": "Care ကို အပ်ဒိတ်လုပ်လို့ မရပါ။",
  "Could not update this challenge.": "ဒီစိန်ခေါ်မှုကို အပ်ဒိတ်လုပ်လို့ မရပါ။",
  "Could not update this connection.": "ဒီချိတ်ဆက်မှုကို အပ်ဒိတ်လုပ်လို့ မရပါ။",
  "Ludo request failed.": "Ludo လုပ်ဆောင်ချက် မအောင်မြင်ပါ။",
  "Could not update matchmaking.": "လူရှာခြင်းကို အပ်ဒိတ်လုပ်လို့ မရပါ။",
  "Could not load moderation.": "စီမံခန့်ခွဲမှုကို ဖွင့်လို့ မရပါ။",
  "Could not save moderation.": "စီမံခန့်ခွဲမှုကို မသိမ်းနိုင်ပါ။",
  "Could not load UTAGE Moments.": "UTAGE Moments ကို ဖွင့်လို့ မရပါ။",
  "Could not update your UTAGE profile.": "သင့် UTAGE ပရိုဖိုင်ကို အပ်ဒိတ်လုပ်လို့ မရပါ။",
  "Photo editor unavailable.": "ဓာတ်ပုံပြင်ဆင်ကိရိယာ မရနိုင်ပါ။",
  "That photo is still too large. Try another one.": "ဒီဓာတ်ပုံ ကြီးလွန်းနေပါသေးတယ်။ တခြားတစ်ပုံ စမ်းကြည့်ပါ။",
  "Could not prepare this quiz replay.": "ဒီမေးခွန်းဂိမ်း Replay ကို မပြင်ဆင်နိုင်ပါ။",
  "Could not make this quiz replay yet.": "ဒီမေးခွန်းဂိမ်း Replay ကို မပြုလုပ်နိုင်သေးပါ။",
  "Could not prepare the quiz replay download.": "Replay ဒေါင်းလုဒ်ကို မပြင်ဆင်နိုင်ပါ။",
  "Could not update this quiz.": "ဒီမေးခွန်းဂိမ်းကို အပ်ဒိတ်လုပ်လို့ မရပါ။",
  "That picture is still too large. Try another one.": "ဒီပုံ ကြီးလွန်းနေပါသေးတယ်။ တခြားတစ်ပုံ စမ်းကြည့်ပါ။",
  "Could not prepare this replay.": "ဒီ Replay ကို မပြင်ဆင်နိုင်ပါ။",
  "Could not make this replay yet.": "ဒီ Replay ကို မပြုလုပ်နိုင်သေးပါ။",
  "Could not prepare the download yet.": "ဒေါင်းလုဒ်ကို မပြင်ဆင်နိုင်သေးပါ။",
  "Could not update this SAY IT moment.": "ဒီ SAY IT ကို အပ်ဒိတ်လုပ်လို့ မရပါ။",
  "Session restore failed.": "ဂိမ်းကို ပြန်မဖွင့်နိုင်ပါ။",
  "Could not end this game yet.": "ဒီဂိမ်းကို အဆုံးမသတ်နိုင်သေးပါ။",
  "Could not confirm that the game ended yet.": "ဂိမ်းပြီးဆုံးကြောင်း မအတည်ပြုနိုင်သေးပါ။",
  // Text drawn inside arcade games
  "LEVEL": "အဆင့်",
  "HOLE": "တွင်း",
  "BOSS": "BOSS",
  "BOSS · {n} PINS": "BOSS · ပင် {n} ခု",
  "GLOWING ARROWS CAN LEAVE NOW": "အလင်းပြနေတဲ့ မြှားတွေ အခု ထွက်လို့ရပြီ",
  "BOARD {n}": "ဘုတ် {n}",
  "BOARD {n} TIME": "ဘုတ် {n} · အချိန်ကုန်",
  "SCORE {score}": "အမှတ် {score}",
  "BEST {score}": "အကောင်းဆုံး {score}",
  "FIRST RUN": "ပထမဆုံးပွဲ",
  "BEAT {score}": "{score} ကို ကျော်ပါ",
  "TAP TO JUMP": "နှိပ်ပြီး ခုန်",
  "TAP THE RHYTHM": "စည်းချက်အတိုင်း နှိပ်",
  "LEVEL {n}": "အဆင့် {n}",
  "CHAIN 0": "ဆက်တိုက် 0",
  "DRAG TO THE GAP": "ကွက်လပ်ဆီ ဆွဲ",
  "INFERNO": "မီးလောင်နေပြီ",
  "CHAIN {n}": "ဆက်တိုက် {n}",
  "TAP TO TURN": "နှိပ်ပြီး လှည့်",
  "LEFT SIDE / RIGHT SIDE": "ဘယ်ဘက် / ညာဘက်",
  "TAP FORWARD · SWIPE SIDEWAYS": "ရှေ့သွားဖို့ နှိပ် · ဘေးကို ပွတ်ဆွဲ",
  "BLOCK {n} CLEAR": "ဘလောက် {n} ကျော်ပြီ",
  "SWIPE TO TURN": "ပွတ်ဆွဲပြီး လှည့်",
  "{score} FOOD": "အစာ {score} ခု",
  "WATCH · REPEAT": "ကြည့် · ပြန်လုပ်",
  "TAP TO CHANGE COLOR": "နှိပ်ပြီး အရောင်ပြောင်း",
  "DRAG THE PADDLE · 3 LIVES": "ဘတ်ကို ဆွဲ · အသက် ၃ ခု",
  "{n} LIFE LEFT": "အသက် {n} ခု ကျန်",
  "{n} LIVES LEFT": "အသက် {n} ခု ကျန်",
  "SWIPE ANYWHERE · PULL OR FLICK": "ဘယ်နေရာမဆို ပွတ်ဆွဲ · ဆွဲ ဒါမှမဟုတ် ပစ်",
  "{n} BUMPER": "အတားအဆီး {n} ခု",
  "{n} BUMPERS": "အတားအဆီး {n} ခု",
  "{score} POINTS": "{score} မှတ်",
  "HOLE {n} CLEAR": "တွင်း {n} ဝင်ပြီ",
  "FLICK TOWARD GOAL · 3 MISSES": "ဂိုးဘက် ပစ် · လွဲခွင့် ၃ ကြိမ်",
  "SWIPE TARGETS · AVOID BOMBS": "ပစ်မှတ်ကို ပွတ်ဆွဲ · ဗုံးကို ရှောင်",
  "TAP TO TURN IN AIR": "လေထဲမှာ နှိပ်ပြီး လှည့်",
  "FLICK UP TOWARD THE HOOP": "ကွင်းဘက် အပေါ်ကို ပစ်",
  "ANGLE + SWIPE SPEED CONTROL THE SHOT": "ထောင့် + ပွတ်ဆွဲအမြန်နှုန်းက ပစ်ချက်ကို ထိန်းတယ်",
  "SWISH +{n}": "ထိပ်ဆုံးဝင် +{n}",
  "{n} MISS LEFT": "လွဲခွင့် {n} ကြိမ် ကျန်",
  "{n} MISSES LEFT": "လွဲခွင့် {n} ကြိမ် ကျန်",
  "TAP · TIME THE GAP": "နှိပ် · ကွက်လပ်ကို အချိန်ကိုက်",
  "CORE CLEARED": "ဗဟို ရှင်းပြီ",
  "YOUR TURN · 45 SECONDS · SEND THIS RUN": "သင့်အလှည့် · ၄၅ စက္ကန့် · ဒီပွဲကို ပို့",
  "+3 GOAL": "+3 ဂိုး",
  "YOUR TURN · DRAG THE BLUE MALLET": "သင့်အလှည့် · အပြာရောင် ဒိုင်းကို ဆွဲ",
  "GOAL": "ဂိုး",
  "{score} GOALS": "{score} ဂိုး",
  "GET READY": "အဆင်သင့် ပြင်",
  "7 reaction tests · same delays for both players": "တုံ့ပြန်မှု စမ်းသပ်ချက် ၇ ခု · ကစားသူနှစ်ယောက်လုံး အချိန်တူ",
  "{score} REACTION PTS": "တုံ့ပြန်မှု {score} မှတ်",
  "WAIT…": "စောင့်…",
  "Tap only when the screen says NOW": "NOW! ပေါ်မှသာ နှိပ်ပါ",
  "NOW!": "NOW!",
  "TAP!": "နှိပ်!",
  "+{n} points": "+{n} မှတ်",
  "TOO EARLY": "စောလွန်းတယ်",
  "+0 points": "+0 မှတ်",
  "TAP TO DROP": "နှိပ်ပြီး ချ",
  "PERFECT ×{n}": "အပြည့် ×{n}",
  // Goal Shot results
  "SAVED": "ဂိုးသမား ကာလိုက်ပြီ",
  "WIDE": "ဘေးကို လွဲသွားပြီ",
  // Hoop
  "WIND {arrows}": "လေ {arrows}",
  "STREAK ×{n}": "ဆက်တိုက် ×{n}",
  // Profile settings
  "SETTINGS": "ဆက်တင်များ",
  "TEXT SIZE": "စာလုံးအရွယ်",
  "SMALL": "သေး",
  "LARGE": "ကြီး",
  "GAME SOUNDS": "ဂိမ်းအသံ",
  "VIBRATION": "တုန်ခါမှု",
  "OFF": "ပိတ်",
  "PROFILE": "ပရိုဖိုင်",
};
